webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return generateUUID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUrlWebSocket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return unifiedInboxNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getNavigatorLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return invertColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isIOS; });
/* unused harmony export windowsOS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_js__ = __webpack_require__(17);


var generateUUID = function generateUUID() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }

    return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
};

var getUrlWebSocket = function getUrlWebSocket(ip, guid) {
    return "wss://" + ip + "/websockets/webmessages/" + guid;
};

var unifiedInboxNotification = function unifiedInboxNotification(titleText, bodyText, method, image) {
    if (typeof Notification !== "undefined" && typeof Notification !== "null") {
        if (__WEBPACK_IMPORTED_MODULE_0__store_js__["a" /* default */].state.notifications.notifications) {
            if (Notification.permission === "granted") {
                var noty = navigator.serviceWorker.ready.then(function (registration) {
                    registration.showNotification(titleText, {
                        body: bodyText,
                        icon: image,
                        vibrate: [200, 100, 200, 100, 200, 100, 200],
                        tag: "vibration-sample",
                        dir: "ltr",
                        lang: "en" });
                });
                noty.onclick = function () {
                    window.focus();
                    noty.close();
                    method();
                };
            } else {
                window.parent.postMessage({ action: 'REQUEST_NOTIFICATION_PERMISSION' }, "*");
            }
        }
    }
};

var getNavigatorLanguage = function getNavigatorLanguage() {
    var arr = ["en", "es", "bn", "lv", "it"];
    var lang = window.navigator.language.split("-")[0];

    for (var i = 0; i < arr.length; i++) {
        if (arr[i] === lang) return lang;
    }

    return "en";
};

var invertColor = function invertColor() {
    var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "#FFFFFF";
    var bw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var menuList = arguments[2];

    if (menuList) {
        return hex;
    }
    function padZero(str, len) {
        len = len || 2;
        var zeros = new Array(len).join("0");
        return (zeros + str).slice(-len);
    }

    if (hex.indexOf("#") === 0) {
        hex = hex.slice(1);
    }

    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error("Invalid HEX color.");
    }
    var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);

    if (bw) {
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#0F120F" : "#F1F2EB";
    }
};

var checkMobile = function checkMobile() {

    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
        return true;
    }
    return false;
};

var isIOS = function isIOS() {
    return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    );
};

var windowsOS = function windowsOS() {
    return !!(window.navigator.userAgent.search(/Windows/) + 1);
};

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_utils__ = __webpack_require__(3);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var state = {
    isMobile: false,
    isIOS: false,
    isLowRes: false,
    currentURL: '',

    menu: {
        menu_title: '',
        menu_img: ''
    },
    configuration: {
        ip: '',
        campaign: ''
    },
    campaign: {
        onTime: false,
        messages: {
            es: '',
            en: '',
            pt: ''
        },
        feedback: ''
    },
    client: {
        lang: '',
        guid: '',
        name: '',
        mail: '',
        number: '',
        initialMessage: '',
        typingText: '',
        rating: 0,
        sendmail: false,
        surveyMessage: '',
        ipAddress: ''
    },
    interaction: {
        active: false,

        state: 'notstarted',
        transfering: false,
        messages: [],
        unreadMessages: 0,
        guid: '',
        agent: '',
        holdTime: 0,
        telAgent: '',
        endConv: false
    },
    notifications: {
        notifications: true
    },
    open: true,
    isExternalWindow: false,
    firstMessageDisplayed: false,
    lastOneMe: null,
    lastOneAgent: null
};

var mutations = {
    startTransfering: function startTransfering(state) {
        state.interaction.transfering = true;
    },
    endTransfering: function endTransfering(state) {
        state.interaction.transfering = false;
    },
    changeFirstMessageDisplayed: function changeFirstMessageDisplayed(state) {
        state.firstMessageDisplayed = !state.firstMessageDisplayed;
    },
    changeTitle: function changeTitle(state, param) {
        state.menu.menu_title = param;
    },
    changeImage: function changeImage(state, param) {
        state.menu.menu_img = param;
    },
    addConfiguration: function addConfiguration(state, payload) {
        for (var key in payload.param) {
            state.configuration[key] = payload.param[key];
        }
    },
    setOnTime: function setOnTime(state, payload) {
        state.campaign = payload.param;

        if (!state.campaign.onTime) {
            state.menu.menu_title = 'Offline';
        }
    },
    setFeedback: function setFeedback(state, value) {
        state.feedback = value;
    },
    setIpAddress: function setIpAddress(state, value) {
        state.client.ipAddress = value;
    },
    isMobile: function isMobile(state, mobile) {
        state.isMobile = mobile;
    },
    isIOS: function isIOS(state, ios) {
        state.isIOS = ios;
    },
    isLowRes: function isLowRes(state, isLow) {
        state.isLowRes = isLow;
    },
    currentURL: function currentURL(state, URL) {
        state.currentURL = URL;
    },
    setNameClient: function setNameClient(state, param) {
        state.client.name = param;
    },
    setEmailClient: function setEmailClient(state, param) {
        state.client.mail = param;
    },
    setNumberClient: function setNumberClient(state, param) {
        state.client.number = param;
    },
    setInitialMessageClient: function setInitialMessageClient(state, param) {
        state.client.initialMessage = param;
    },
    changeGuidInteraction: function changeGuidInteraction(state, param) {
        state.interaction.guid = param;
    },
    changeHoldTime: function changeHoldTime(state, param) {
        state.interaction.holdTime = param;
    },
    waitingInteraction: function waitingInteraction(state) {
        state.interaction.state = 'waiting';
        state.interaction.active = true;
        state.configuration.name = '';
        state.configuration.mail = '';
        state.configuration.initialMessage = '';
    },
    connectedInteraction: function connectedInteraction(state) {
        state.interaction.state = 'started';
    },
    finishedInteraction: function finishedInteraction(state) {
        state.interaction.state = 'finished';
        state.configuration.name = '';
        state.configuration.mail = '';
        state.configuration.initialMessage = '';
    },
    noStartedInteraction: function noStartedInteraction(state) {
        state.interaction.state = 'notstarted';
    },
    nameImage: function nameImage(state, name) {
        state.menu.menu_img = 'https://' + state.configuration.ip + '/images/' + name.replace(/\s+/g, '') + '.jpg';
    },
    nameAgent: function nameAgent(state, param) {
        if (param) {
            state.menu.menu_title = param;
            state.interaction.agent = param;
        }
    },
    telAgent: function telAgent(state, param) {
        state.interaction.telAgent = param;
    },
    username: function username(state, param) {
        state.interaction.username = param;
    },
    newMessage: function newMessage(state, message) {
        if (message.self) {
            if (state.lastOneMe) {
                state.lastOneMe.lastOne = false;
            }
            state.lastOneMe = message;
        } else {
            if (state.lastOneAgent) {
                state.lastOneAgent.lastOne = false;
            }
            state.lastOneAgent = message;
        }

        var position = state.interaction.messages.push(message);
        message.position = position - 1;
        message.optionClicked = false;
    },
    updateMessage: function updateMessage(state, message) {
        state.interaction.messages[message.position] = message;
    },
    clearInteraction: function clearInteraction(state) {
        state.interaction.messages = [];
        state.interaction.guid = '';
        state.interaction.agent = '';
        state.interaction.holdTime = 0;
        state.interaction.telAgent = '';
        state.menu.menu_title = '';
    },
    newGuid: function newGuid(state) {
        state.client.guid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_utils__["g" /* generateUUID */])();
    },
    setTypingText: function setTypingText(state, param) {
        state.client.typingText = param;
    },
    clearMessage: function clearMessage(state) {
        state.client.typingText = '';
    },
    setRatingValue: function setRatingValue(state, value) {
        state.client.rating = value;
    },
    setSendMail: function setSendMail(state, value) {
        state.client.sendmail = value;
    },
    setSurveyMessage: function setSurveyMessage(state, value) {
        state.client.surveyMessage = value;
    },
    setNotifications: function setNotifications(state, value) {
        state.notifications.notifications = value;
    },
    setLang: function setLang(state, value) {
        state.client.lang = value;
    },
    setOffline: function setOffline(state) {
        state.campaign.timeOut = true;
    },
    clearInitialMessage: function clearInitialMessage(state) {
        state.client.initialMessage = '';
    },
    clearSurveyMessage: function clearSurveyMessage(state) {
        state.client.surveyMessage = '';
    },
    clearCalification: function clearCalification(state) {
        state.client.rating = 0;
    },
    setEventState: function setEventState(state, value) {
        state.eventState = value;
    },
    setClientInfo: function setClientInfo(state, param) {
        state.client.name = param.name;
        state.client.mail = param.mail;
        state.client.number = param.number;
        state.client.initialMessage = param.initialMessage;
    },
    toggleOpen: function toggleOpen(state) {
        state.open = !state.open;
    },
    restartUnreadedMessagesCounter: function restartUnreadedMessagesCounter(state) {
        state.interaction.unreadMessages = 0;
    },
    addOneUnreadedMessagesCounter: function addOneUnreadedMessagesCounter(state) {
        state.interaction.unreadMessages++;
    },
    changeIsExternalWindow: function changeIsExternalWindow(state, isExtenal) {
        state.isExternalWindow = isExtenal;
    },
    interactionFinished: function interactionFinished(state) {
        state.interaction.active = false;
        state.interaction.transfering = false;
        state.firstMessageDisplayed = !state.firstMessageDisplayed;
    }
};

var actions = {
    increment: function increment(_ref) {
        var commit = _ref.commit;
        return commit('increment');
    },

    decrement: function decrement(_ref2) {
        var commit = _ref2.commit;
        return commit('decrement');
    },

    incrementIfOdd: function incrementIfOdd(_ref3) {
        var commit = _ref3.commit,
            state = _ref3.state;

        if ((state.count + 1) % 2 === 0) {
            commit('increment');
        }
    },
    incrementAsync: function incrementAsync(_ref4) {
        var commit = _ref4.commit;

        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                commit('increment');
                resolve();
            }, 1000);
        });
    }
};

var getters = {
    hasImageMenuTitle: function hasImageMenuTitle(state) {
        return state.menu.menu_img !== '';
    },

    getClassColorStatus: function getClassColorStatus(state) {
        if (state.campaign.onTime) return 'avaiablecolor';else return 'unavaiablecolor';
    },

    isWaitingInteraction: function isWaitingInteraction(state) {
        return state.interaction.state === 'waiting';
    },

    isStartedInteraction: function isStartedInteraction(state) {
        return state.interaction.state === 'started';
    },

    hasTextareaText: function hasTextareaText(state) {
        return state.client.typingText.trim() !== '';
    },

    messages: function messages(state) {
        return state.interaction.messages;
    },

    imageAgent: function imageAgent(state) {
        return state.menu.menu_title !== 'Chat';
    },

    getMainTitle: function getMainTitle(state) {
        if (state.menu.menu_title) return state.menu.menu_title;else {
            if (state.campaign.onTime) return 'Chat';else return 'Offline';
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default()()]
}));

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _Object$freeze;

/* harmony default export */ __webpack_exports__["a"] = (Object.freeze((_Object$freeze = {
    NOT_STARTED_STATE: 'notstarted',
    STARTED_STATE: 'started',
    WAITING_STATE: 'waiting',
    FINISHED_STATE: 'finished',

    WS_CHAT_CREATED: 'chatcreated',
    WS_CONNECTED: 'connected',
    WS_NEW_MESSAGE: 'newmessage',
    WS_CHAT_FINISHED: 'finishchat',
    WS_TYPING: 'typing',
    WS_TIMEOUT: 'timeout',
    WS_TRANSFERRED: 'transferred',
    WS_ATTENDED: 'attended'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Object$freeze, 'WS_TYPING', 'typing'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Object$freeze, 'WS_REQUEST_SCREEN', 'request_screen'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Object$freeze, 'WS_SIGNALLING', 'signalling'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Object$freeze, 'WS_NOT_SUPPORTED', 'not_supported'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Object$freeze, 'WS_DENIED', 'denied'), _Object$freeze)));

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports) {

module.exports = {"_args":[["jssip@3.7.0","/home/runner/work/uContact/uContact/FrontEnd/webchatclient"]],"_from":"jssip@3.7.0","_id":"jssip@3.7.0","_inBundle":false,"_integrity":"sha512-Uu/Zd6tegShn5jxRXnBxlIrMVxzPDXrx7smppg2paKG6YGx5mWL0LxKg0SjxY0cd+9YfRpu9DHxeGRBugVprfg==","_location":"/jssip","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"jssip@3.7.0","name":"jssip","escapedName":"jssip","rawSpec":"3.7.0","saveSpec":null,"fetchSpec":"3.7.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/jssip/-/jssip-3.7.0.tgz","_spec":"3.7.0","_where":"/home/runner/work/uContact/uContact/FrontEnd/webchatclient","author":{"name":"José Luis Millán","email":"jmillan@aliax.net","url":"https://github.com/jmillan"},"bugs":{"url":"https://github.com/versatica/JsSIP/issues"},"contributors":[{"name":"Iñaki Baz Castillo","email":"ibc@aliax.net","url":"https://github.com/ibc"}],"dependencies":{"@types/debug":"^4.1.5","@types/node":"^14.14.13","debug":"^4.3.1","events":"^3.2.0","sdp-transform":"^2.14.1"},"description":"the Javascript SIP library","devDependencies":{"@babel/core":"^7.12.10","@babel/preset-env":"^7.12.10","ansi-colors":"^3.2.4","browserify":"^16.5.1","eslint":"^5.16.0","fancy-log":"^1.3.3","gulp":"^4.0.2","gulp-babel":"^8.0.0","gulp-eslint":"^5.0.0","gulp-expect-file":"^1.0.2","gulp-header":"^2.0.9","gulp-nodeunit-runner":"^0.2.2","gulp-plumber":"^1.2.1","gulp-rename":"^1.4.0","gulp-uglify-es":"^1.0.4","pegjs":"^0.7.0","vinyl-buffer":"^1.0.1","vinyl-source-stream":"^2.0.0"},"homepage":"https://jssip.net","keywords":["sip","websocket","webrtc","node","browser","library"],"license":"MIT","main":"lib-es5/JsSIP.js","name":"jssip","repository":{"type":"git","url":"git+https://github.com/versatica/JsSIP.git"},"scripts":{"lint":"gulp lint","prepublishOnly":"gulp babel","test":"gulp test"},"title":"JsSIP","types":"lib/JsSIP.d.ts","version":"3.7.0"}

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(321)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(413),
  /* scopeId */
  "data-v-e1a99154",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(308)
__webpack_require__(309)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(403),
  /* scopeId */
  "data-v-21bb7960",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(317)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(409),
  /* scopeId */
  "data-v-5ff39e04",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */,
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.chat = null;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "sendMessage",
        value: function sendMessage(text) {
            if (this.chat) this.chat.sendOnlyText(text);
        }
    }, {
        key: "subscribeChat",
        value: function subscribeChat(chat) {
            this.chat = chat;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
  function _class(store) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.store = store;
    window.addEventListener("message", function (event) {
      switch (event.data.action) {
        case "ISLOWRES":
          _this.store.commit('isLowRes', event.data.state);
          break;
        case "CURRENT_URL":
          _this.chat.currentUrl(event.data.state);
          break;
        case "RELOAD":
          window.location.reload();
          break;
      }
    });
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: "susbscribeChat",
    value: function susbscribeChat(chat) {
      this.chat = chat;
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__en__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__es__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bn__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lv__ = __webpack_require__(259);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var messages = {
  en: __WEBPACK_IMPORTED_MODULE_4__en__["a" /* default */], es: __WEBPACK_IMPORTED_MODULE_5__es__["a" /* default */], bn: __WEBPACK_IMPORTED_MODULE_6__bn__["a" /* default */], lv: __WEBPACK_IMPORTED_MODULE_7__lv__["a" /* default */]
};

var lang = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_utils__["f" /* getNavigatorLanguage */])();
__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setLang', lang);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: lang,
  messages: messages
}));

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_call__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_call___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_call__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chat__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_form__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_survey__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_survey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_survey__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_4__components_form___default.a
  }, {
    path: '/call',
    name: 'call',
    component: __WEBPACK_IMPORTED_MODULE_2__components_call___default.a
  }, {
    path: '/chat',
    name: 'chat',
    component: __WEBPACK_IMPORTED_MODULE_3__components_chat___default.a
  }, {
    path: '/form',
    name: 'form',
    component: __WEBPACK_IMPORTED_MODULE_4__components_form___default.a
  }, {
    path: '/survey',
    name: 'survey',
    component: __WEBPACK_IMPORTED_MODULE_5__components_survey___default.a
  }]
}));

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */,
/* 233 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(324)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(415),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chat__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_EventsLog__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_Constants__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_welcome_message_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_welcome_message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_welcome_message_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: {
    Chat: __WEBPACK_IMPORTED_MODULE_3__components_chat___default.a,
    WelcomeMessage: __WEBPACK_IMPORTED_MODULE_6__components_welcome_message_vue___default.a
  },

  data: function data() {
    return {
      allowedDomain: true,
      eventsLog: new __WEBPACK_IMPORTED_MODULE_4__assets_EventsLog__["a" /* default */](this.$http),
      broadcastedColor: false
    };
  },


  computed: {
    showWelcome: function showWelcome() {
      var interactionState = this.$store.state.interaction.state;
      return interactionState != __WEBPACK_IMPORTED_MODULE_5__assets_Constants__["a" /* default */].STARTED_STATE && interactionState != __WEBPACK_IMPORTED_MODULE_5__assets_Constants__["a" /* default */].FINISHED_STATE;
    }
  },

  created: function created() {
    this.init();
  },


  methods: {
    init: function init() {
      if (this.$route.query.ip) {
        this.$store.commit({
          type: "addConfiguration",
          param: this.$route.query
        });
      }

      this.isOnTime();
      this.checkRouter();
      this.appReady();
    },
    appReady: function appReady() {
      this.$store.commit("isMobile", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_utils__["a" /* checkMobile */])());
      this.$store.commit("isIOS", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_utils__["b" /* isIOS */])());
    },
    hasParameters: function hasParameters() {
      return this.$store.state.configuration.name && this.$store.state.configuration.mail && this.$store.state.configuration.initialMessage;
    },
    startChatWithParameters: function startChatWithParameters() {
      this.$store.commit("setClientInfo", {
        name: this.$store.state.configuration.name,
        mail: this.$store.state.configuration.mail,
        number: this.$store.state.configuration.number || '',
        initialMessage: this.$store.state.configuration.initialMessage
      });
      this.$store.commit("newGuid");
      this.$router.replace("chat");
    },
    checkRouter: function checkRouter() {
      var state = this.$store.state.interaction.state;
      if (state === __WEBPACK_IMPORTED_MODULE_5__assets_Constants__["a" /* default */].NOT_STARTED_STATE) {
        if (this.hasParameters()) {
          this.startChatWithParameters();
        } else {
          this.$router.replace("form");
        }
      } else if (state === __WEBPACK_IMPORTED_MODULE_5__assets_Constants__["a" /* default */].WAITING_STATE || state === __WEBPACK_IMPORTED_MODULE_5__assets_Constants__["a" /* default */].STARTED_STATE) {
        this.$router.replace("chat");
      } else if (state === __WEBPACK_IMPORTED_MODULE_5__assets_Constants__["a" /* default */].FINISHED_STATE) {
        this.$router.replace("form");
      }
    },
    isOnTime: function isOnTime() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$http.get("https://" + _this.$store.state.configuration.ip + "/IntegraChannels/resources/webchat/isOnTime", {
                  params: {
                    campaign: _this.$store.state.configuration.campaign
                  }
                });

              case 3:
                response = _context.sent;

                _this.onResponseTime(response.data);

                if (!_this.broadcastedColor) {
                  setTimeout(function () {
                    window.parent.postMessage({ action: "SET_COLOR", color: response.data.color }, "*");
                  }, 500);
                  _this.broadcastedColor = true;
                }
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                _this.$store.commit("setOnTime", { param: { onTime: false } });
                console.log("ERROR FETCHING INFO:" + _context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },

    onResponseTime: function onResponseTime(response) {
      if (!response) return;
      response.outoftime = JSON.parse(response.outoftime);
      response.welcome = JSON.parse(response.welcome);
      response.feedback = JSON.parse(response.feedback);

      var allowedDomain = window.location.href.indexOf(response.allowedDomains || "") > -1;

      if (!response.allowedDomains || response.allowedDomains && allowedDomain) {
        if (response.custom_field) {
          response.custom_field = JSON.parse(response.custom_field);
        } else {
          response.custom_field = {
            required: false,
            visible: true,
            text: {
              en: "Phone Number",
              es: "Telefono",
              pt: "Telefone"
            }
          };
        }

        var defaultobj = {
          es: "No disponible",
          en: "Not available",
          pt: "Não disponível"
        };

        if (response.notavailablemessage) {
          response.notavailablemessage = JSON.parse(response.notavailablemessage);
          if (!response.notavailablemessage.es && !response.notavailablemessage.en && !response.notavailablemessage.pt) {
            response.notavailablemessage = defaultobj;
          }
        } else {
          response.notavailablemessage = defaultobj;
        }

        this.$store.commit({ type: "setOnTime", param: response });

        this.$store.commit("setFeedback", response.feedback);

        this.$store.commit("setIpAddress", response.ipAddress);

        if (!response.available) {
          setTimeout(this.isOnTime, 10000);
        }
      } else {
        this.allowedDomain = false;
      }
    }
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    files: Array
  },
  name: 'attachments',
  data: function data() {
    return {
      arr: []
    };
  },


  methods: {
    isImage: function isImage(e) {
      var arr = e.split('|');
      if (arr[0] === 'image') {
        return true;
      } else return false;
    },
    isVideo: function isVideo(e) {
      var arr = e.split('|');
      if (arr[0] === 'video') {
        return true;
      } else return false;
    },
    isAudio: function isAudio(e) {
      var arr = e.split('|');
      if (arr[0] === 'audio') {
        return true;
      } else return false;
    },
    getSrc: function getSrc(e) {
      return 'https://' + this.$store.state.configuration.ip + '/attachments/' + e.split('|')[1];
    },
    getNameFile: function getNameFile(e) {
      if (e.indexOf('>') > -1) {
        var index = e.indexOf('>');
        return e.substr(index + 1, e.length);
      } else {
        var arr = e.split('/');
        var name = arr[arr.length - 1];
        return name.substr(36, name.length);
      }
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_WebRTCPhone__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chronometer_vue__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chronometer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__chronometer_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: { show: Boolean, video: Boolean },
  name: 'call',
  components: {
    Chronometer: __WEBPACK_IMPORTED_MODULE_1__chronometer_vue___default.a
  },

  data: function data() {
    return {
      phone: null,
      mute: false,
      showVideo: true,
      isOnVideoCall: false
    };
  },


  watch: {
    show: function show() {
      if (this.show) {
        this.initTelephony();
      }
    }
  },

  created: function created() {
    if (this.video) {
      this.showVideo = true;
    }
  },
  mounted: function mounted() {
    this.initTelephony();
  },


  methods: {
    initTelephony: function initTelephony() {
      var _this = this;

      if (this.show) {
        var agentself = this.$refs.agentself;
        var myself = this.$refs.myself;

        var tel = this.$store.state.campaign.telServer;
        var campaign = this.$store.state.configuration.campaign;
        var guid = this.$store.state.interaction.guid;

        var stunTurnConfs = {
          ScreenShareTurn: this.$store.state.campaign.ScreenShareTurn,
          ScreenShareTurnPass: this.$store.state.campaign.ScreenShareTurnPass,
          ScreenShareTurnUser: this.$store.state.campaign.ScreenShareTurnUser
        };

        this.phone = new __WEBPACK_IMPORTED_MODULE_0__assets_WebRTCPhone__["a" /* default */](tel, campaign, guid, stunTurnConfs, function () {
          _this.hangup();
        });

        this.$emit('phone', this.phone);

        this.phone.setVideoElements(myself, agentself, this.$store);

        this.phone.startUA();
        this.phone.makeCall(this.$store.state.interaction.telAgent, this.video);
      }
    },
    hangup: function hangup() {
      this.$emit('hangupEv');
      if (this.phone) this.phone.hangUp();else {
        window.close();
      }
    },
    mutebutton: function mutebutton() {
      this.mute = !this.mute;
      if (this.mute) this.phone.mute();else this.phone.unmute();
    },
    switchShowVideo: function switchShowVideo() {
      this.showVideo = !this.showVideo;
      this.showTextInput = !this.showTextInput;
      this.$emit('hideTextAreaEv');
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_detectrtc__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_detectrtc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_detectrtc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_avatar_png__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_avatar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_avatar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_utils__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "chat-toolbar",
  props: { hideEndConv: Boolean, isBot: Boolean },
  data: function data() {
    return {
      avatar: __WEBPACK_IMPORTED_MODULE_1__assets_avatar_png___default.a,
      hasWebRTC: false
    };
  },


  computed: {
    getVisiblePhoneIcons: function getVisiblePhoneIcons() {
      return this.hasWebRTC;
    },
    isIOS: function isIOS() {
      return this.$store.state.isIOS;
    },
    isMobile: function isMobile() {
      return this.$store.state.isMobile;
    },
    allowedCalls: function allowedCalls() {
      return this.$store.state.campaign.allow_call;
    },
    hideButtons: function hideButtons() {
      return this.hideEndConv || this.isBot;
    }
  },

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_detectrtc___default.a.load(function () {
      _this.hasWebRTC = __WEBPACK_IMPORTED_MODULE_0_detectrtc___default.a.isWebRTCSupported;
    });
  },


  methods: {
    isChrome: function isChrome() {
      return navigator.userAgent.indexOf("CriOS") > -1;
    },
    makeCall: function makeCall() {
      this.$emit("clickCallEv");
    },
    videoCall: function videoCall() {
      this.$emit("clickVideoCallEv");
    },
    openCloseModal: function openCloseModal() {
      this.$emit("openConfirmationModal");
    },
    minimizeWindow: function minimizeWindow() {
      window.parent.postMessage({ action: "MINIMIZE" }, "*");
    },


    invertColor: __WEBPACK_IMPORTED_MODULE_2__assets_utils__["c" /* invertColor */]
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_Constants__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__message__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__call_vue__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__call_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__call_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_Attachments__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_detectrtc__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_detectrtc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_detectrtc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chronometer__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chronometer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__chronometer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__chat_toolbar__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__chat_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__chat_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__closing_dialog__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__closing_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__closing_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__screen_share_dialog__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__screen_share_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__screen_share_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_chat_background2_svg__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_chat_background2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_chat_background2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_ScreenShareController__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_reconnecting_websocket__ = __webpack_require__(359);





















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Message: __WEBPACK_IMPORTED_MODULE_6__message___default.a,
    Call: __WEBPACK_IMPORTED_MODULE_7__call_vue___default.a,
    Chronometer: __WEBPACK_IMPORTED_MODULE_10__chronometer___default.a,
    ChatToolbar: __WEBPACK_IMPORTED_MODULE_11__chat_toolbar___default.a,
    ClosingDialog: __WEBPACK_IMPORTED_MODULE_12__closing_dialog___default.a,
    ScreenShareDialog: __WEBPACK_IMPORTED_MODULE_13__screen_share_dialog___default.a
  },
  name: "chat",
  data: function data() {
    return {
      showModalAbandon: false,
      interval: null,
      websocket: null,
      usertyping: false,
      windowcall: null,
      attachments: new __WEBPACK_IMPORTED_MODULE_8__assets_Attachments__["a" /* default */](this.$http),
      transfering: false,
      isOnVideoCall: false,
      isInCall: false,
      showTextInput: true,
      showClosingDialog: false,
      lastOneMe: null,
      lastOneAgent: null,
      background: __WEBPACK_IMPORTED_MODULE_14__assets_chat_background2_svg___default.a,
      sentTyping: false,

      showWebrtcStream: {
        visible: false,
        dialog: false,
        stream: null
      },
      showEndConv: false,
      endConv: false,
      bot: false,
      screenShareController: null
    };
  },
  created: function created() {

    if (this.$store.state.interaction.guid) {
      this.checkStateOnServer();
    } else {
      this.connectWebSocket();
    }

    this.$eventsManager.susbscribeChat(this);
    this.$eventManagerMenu.subscribeChat(this);

    this.screenShareController = new __WEBPACK_IMPORTED_MODULE_15__assets_ScreenShareController__["a" /* default */](this.sendWebSocket, this.showWebrtcStream, this.$store.state.isMobile);
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    typingText: {
      get: function get() {
        return this.$store.state.client.typingText;
      },
      set: function set(value) {
        this.$store.commit("setTypingText", value);

        if (value && !this.sentTyping) {
          this.sendTyping();
        } else if (!value) {
          this.sendNotTyping();
        }
      }
    },

    typingVisible: function typingVisible() {
      return this.usertyping;
    },


    notif: {
      get: function get() {
        return this.$store.state.notifications.notifications;
      },
      set: function set(value) {
        this.$store.commit("setNotifications", value);
      }
    }

  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
    imageAgent: "imageAgent"
  })),

  watch: {},

  mounted: function mounted() {
    this.scrollBottom();
  },


  methods: {
    onPhone: function onPhone(phone) {
      phone.chat = this;
    },

    invertColor: __WEBPACK_IMPORTED_MODULE_4__assets_utils__["c" /* invertColor */],

    hasParameters: function hasParameters() {
      return this.$store.state.configuration.name && this.$store.state.configuration.mail && this.$store.state.configuration.initialMessage;
    },
    menuMessageEvent: function menuMessageEvent(obj) {
      this.lastMenuMessage = obj;
    },
    disableLastMenuMessage: function disableLastMenuMessage(message) {
      if (this.lastMenuMessage) {
        this.lastMenuMessage.disableMenuMessage(message);
      }
    },
    checkStateOnServer: function checkStateOnServer() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$http.get("https://" + _this.$store.state.configuration.ip + "/IntegraChannels/resources/webchat/thisGuid", {
                  params: {
                    guid: _this.$store.state.interaction.guid
                  }
                });

              case 3:
                response = _context.sent;


                if (!response.body[0]) {
                  _this.$router.replace("form");
                } else {
                  _this.connectWebSocket();
                }
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                _this.$router.replace("form");

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    connectWebSocket: function connectWebSocket() {
      var _this2 = this;

      var ip = this.$store.state.configuration.ip;
      var useruuid = this.$store.state.client.guid;
      this.websocket = new __WEBPACK_IMPORTED_MODULE_16_reconnecting_websocket__["a" /* default */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__assets_utils__["d" /* getUrlWebSocket */])(ip, useruuid));
      this.websocket.timeoutInterval = 5000;
      this.websocket.maxReconnectInterval = 5000;
      this.websocket.reconnectDecay = 1.1;
      this.websocket.onopen = this.onOpenWebSocket;
      this.websocket.onmessage = this.onMessageWebSocket;
      this.websocket.onclose = this.onCloseWebSocket;
      this.interval = setInterval(function () {
        _this2.sendWebSocket({});
      }, 30000);
    },
    onOpenWebSocket: function onOpenWebSocket(event) {
      if (this.$store.state.interaction.state === __WEBPACK_IMPORTED_MODULE_3__assets_Constants__["a" /* default */].NOT_STARTED_STATE) {
        this.startChat();
      } else {
        window.parent.postMessage({ action: "CURRENT_URL" }, "*");
      }
    },
    onCloseWebSocket: function onCloseWebSocket(event) {
      console.log('websocket disconnected');
    },
    onMessageWebSocket: function onMessageWebSocket(event) {
      var msj = JSON.parse(event.data);
      switch (msj.subtype) {
        case __WEBPACK_IMPORTED_MODULE_3__assets_Constants__["a" /* default */].WS_CHAT_CREATED:
          this.chatCreated(msj);
          break;
        case __WEBPACK_IMPORTED_MODULE_3__assets_Constants__["a" /* default */].WS_CONNECTED:
          this.connected(msj);
          break;
        case __WEBPACK_IMPORTED_MODULE_3__assets_Constants__["a" /* default */].WS_NEW_MESSAGE:
          this.bot = msj.bot;
          this.newMessage(msj);

          if (!this.$store.state.firstMessageDisplayed) {
            if (this.$store.state.campaign.first_message_agent) {
              var message = new Object();
              message.content = this.$store.state.campaign.first_message_agent;
              message.source = this.$store.state.interaction.telAgent;
              this.newMessage(message);
              this.$store.commit("changeFirstMessageDisplayed");
            }
          }
          break;
        case __WEBPACK_IMPORTED_MODULE_3__assets_Constants__["a" /* default */].WS_CHAT_FINISHED:
          this.$store.commit('interactionFinished');
          this.finishChat(msj);
          break;
        case __WEBPACK_IMPORTED_MODULE_3__assets_Constants__["a" /* default */].WS_TYPING:
          this.typing(msj);
          break;
        case __WEBPACK_IMPORTED_MODULE_3__assets_Constants__["a" /* default */].WS_TIMEOUT:
          this.timeOut();
          break;
        case __WEBPACK_IMPORTED_MODULE_3__assets_Constants__["a" /* default */].WS_TRANSFERRED:
          this.bot = false;
          this.$store.commit('startTransfering');
          break;
        case __WEBPACK_IMPORTED_MODULE_3__assets_Constants__["a" /* default */].WS_ATTENDED:
          this.connected(msj);
          this.$store.commit('endTransfering');
          break;
        case __WEBPACK_IMPORTED_MODULE_3__assets_Constants__["a" /* default */].WS_REQUEST_SCREEN:
          this.screenShareController.onMessage(msj);
          break;
        case __WEBPACK_IMPORTED_MODULE_3__assets_Constants__["a" /* default */].WS_SIGNALLING:
          this.screenShareController.onMessage(msj);
          break;
      }
    },
    sendWebSocket: function sendWebSocket(data) {
      if (this.websocket) {
        this.websocket.send(JSON.stringify(data));
      }
    },
    sendTyping: function sendTyping() {
      var msj = {
        type: "webchat",
        subtype: "typing",
        content: "typing",
        source: this.$store.state.client.guid,
        guid: this.$store.state.interaction.guid
      };
      this.sentTyping = true;
      this.sendWebSocket(msj);
    },
    sendStartCallEvent: function sendStartCallEvent(video) {
      var msj = {
        type: "webchat",
        subtype: "startcall",
        content: video ? "video" : "",
        source: this.$store.state.client.guid,
        guid: this.$store.state.interaction.guid
      };
      this.sendWebSocket(msj);
    },
    sendEndCallEvent: function sendEndCallEvent(video) {
      var msj = {
        type: "webchat",
        subtype: "ENDCALL",
        content: video ? "video" : "",
        source: this.$store.state.client.guid,
        guid: this.$store.state.interaction.guid
      };
      this.sendWebSocket(msj);
    },
    sendNotTyping: function sendNotTyping() {
      var msj = {
        type: "webchat",
        subtype: "typing",
        content: "nottyping",
        source: this.$store.state.client.guid,
        guid: this.$store.state.interaction.guid
      };
      this.sentTyping = false;
      this.sendWebSocket(msj);
    },
    startChat: function startChat() {
      this.$store.commit("clearInteraction");

      var msj = {};
      msj.type = "webchat";
      msj.subtype = "startinteraction";
      msj.source = this.$store.state.client.guid;
      msj.content = {};
      msj.content.campaign = this.$store.state.configuration.campaign;
      msj.content.name = this.$store.state.client.name;
      msj.content.mail = this.$store.state.client.mail;
      msj.content.initialMessage = this.$store.state.client.initialMessage;
      msj.content.number = this.$store.state.client.number;
      msj.content.ipAddress = this.$store.state.client.ipAddress;

      this.sendWebSocket(msj);
    },
    chatCreated: function chatCreated(msj) {
      this.$store.commit("waitingInteraction");
      var guid = msj.guid;
      var holdTime = parseInt(msj.content);
      this.$store.commit("changeGuidInteraction", guid);
      this.$store.commit("changeHoldTime", holdTime);
    },
    newMessage: function newMessage(msj) {
      var _this3 = this;

      this.disableLastMenuMessage(true);
      var message = {};
      message.message = msj.content;
      message.date = new Date();
      message.agent = msj.source;
      message.attachments = msj.attachments;
      message.self = msj.source === this.$store.state.client.guid;
      message.lastOne = true;
      this.$store.commit("newMessage", message);
      this.scrollBottom();
      this.$emit("addOneUnreadedMessagesCounter");
      window.parent.postMessage({ action: "NEWMESSAGE", message: message }, "*");
      !this.$store.state.open ? this.$store.commit("addOneUnreadedMessagesCounter") : "";

      if (msj.source !== this.$store.state.client.guid) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__assets_utils__["e" /* unifiedInboxNotification */])(this.$t("newmessage"), msj.content, function () {
          _this3.$refs.textarea.focus();
        }, this.$store.state.menu.menu_img);
      }
    },
    finishChat: function finishChat(msj) {
      window.parent.postMessage({
        action: "FINISH_CHAT",
        state: this.$store.state
      }, "*");
      if (this.interval) clearInterval(this.interval);
      if (this.websocket) this.websocket.close();
      this.endConv = true;
      this.openEndConvModal();
    },
    typing: function typing(msj) {
      if (msj.content === "typing") {
        this.usertyping = true;
        this.scrollBottom();
      } else if (msj.content === "nottyping") {
        this.usertyping = false;
      }
    },
    connected: function connected(msj) {
      this.$store.commit("connectedInteraction");
      if (msj.content) {
        var nombreAgente = msj.content.agent || "Chat";
        var fullname = msj.content.fullname || nombreAgente;
        var telAgente = msj.content.agentnumber;

        if (nombreAgente) this.$store.commit("nameImage", nombreAgente);
        if (fullname) this.$store.commit("nameAgent", fullname);

        this.$store.commit("telAgent", telAgente);
        this.$store.commit("username", msj.content.agent);

        if (this.$store.state.campaign.autoAnswer == 1) this.openWindowCalling();else if (this.$store.state.campaign.autoAnswer == 2) {
          this.openWindowVideocalling();
        }
      }
      window.parent.postMessage({ action: "CURRENT_URL" }, "*");
    },
    sendMessage: function sendMessage(e) {
      if (this.$store.state.client.typingText.trim() !== "") {

        var msj = {};
        msj.type = "webchat";
        msj.subtype = "newmessage";
        msj.source = this.$store.state.client.guid;
        msj.guid = this.$store.state.interaction.guid;
        msj.content = this.$store.state.client.typingText.trim();
        this.disableLastMenuMessage(msj.content);
        this.$store.commit("clearMessage");
        this.sendNotTyping();
        this.sendWebSocket(msj);
      } else {
        this.$store.commit("clearMessage");
      }
    },
    sendCurrentURL: function sendCurrentURL(obj) {
      var msj = {};
      msj.type = "webchat";
      msj.subtype = "currentURL";
      msj.source = this.$store.state.client.guid;
      msj.guid = this.$store.state.interaction.guid;
      msj.content = obj;
      this.sendWebSocket(msj);
    },
    timeOut: function timeOut() {
      if (this.$store.state.interaction.transfering) this.$store.commit('endTransfering');
      this.$store.commit("setOffline");
      this.$router.replace("/form");
    },
    sendFinish: function sendFinish() {
      window.parent.postMessage({
        action: "ABANDON",
        state: this.$store.state
      }, "*");
      var msj = new Object();
      msj.type = "webchat";
      msj.subtype = "finishchat";
      msj.source = this.$store.state.client.guid;
      msj.guid = this.$store.state.interaction.guid;
      this.sendWebSocket(msj);
    },
    openWindowCalling: function openWindowCalling() {
      this.isInCall = true;
    },
    openWindowVideocalling: function openWindowVideocalling() {
      this.isInCall = true;
      this.isOnVideoCall = true;
    },
    hangup: function hangup() {
      this.isInCall = false;
      this.isOnVideoCall = false;
    },
    switchShowTextInput: function switchShowTextInput() {
      this.showTextInput = !this.showTextInput;
    },
    addAttachment: function addAttachment() {
      this.$refs.inputfiles.click();
    },
    scrollBottom: function scrollBottom() {
      var _this4 = this;

      this.$nextTick(function () {
        if (_this4.$refs.olchat) {
          var elem = _this4.$refs.olchat;
          elem.scrollTop = elem.scrollHeight;
        }
      });
    },
    focusTextArea: function focusTextArea() {
      this.$refs.textarea.focus();
    },
    openCloseDialog: function openCloseDialog() {
      this.showClosingDialog = true;
    },
    hideClosingModal: function hideClosingModal() {
      this.showClosingDialog = false;
    },
    clickModalAbandon: function clickModalAbandon() {
      this.showModalAbandon = false;
      this.sendFinish();
      if (this.$store.state.campaign.allow_feedback_client) {
        this.$store.commit("finishedInteraction");
        this.$router.replace("/survey");
      } else {
        this.$store.commit("noStartedInteraction");
        this.$router.replace("/form");
      }
    },
    shouldClose: function shouldClose(confirmation) {
      if (confirmation) {
        if (this.endConv) {
          if (this.$store.state.campaign.allow_feedback_client) {
            this.$store.commit("finishedInteraction");
            this.$router.replace("/survey");
          } else {
            this.$store.commit("noStartedInteraction");
            this.$router.replace("/form");
          }
        }
        this.sendFinish();
      } else {
        this.showClosingDialog = false;
      }
    },
    onFileChange: function onFileChange(e) {
      var _this5 = this;

      this.attachments.addAttachment(e.target.files[0], function (obj) {
        _this5.disableLastMenuMessage(true);
        var msj = new Object();
        msj.type = "webchat";
        msj.subtype = "newmessage";
        msj.source = _this5.$store.state.client.guid;
        msj.guid = _this5.$store.state.interaction.guid;
        msj.content = "";
        msj.attachments = [obj];
        _this5.$store.commit("clearMessage");
        _this5.sendWebSocket(msj);
      });
    },
    currentUrl: function currentUrl(obj) {
      this.sendCurrentURL(obj);
    },
    sendOnlyText: function sendOnlyText(text) {
      var msj = {
        type: "webchat",
        subtype: "newmessage",
        source: this.$store.state.client.guid,
        guid: this.$store.state.interaction.guid,
        content: JSON.stringify(text),
        destination: "agent"
      };
      this.sendWebSocket(msj);
    },
    cancelModalEndConv: function cancelModalEndConv() {
      this.showEndConv = false;
    },
    acceptModalEndConv: function acceptModalEndConv(confirmation) {
      if (confirmation) {
        if (this.$store.state.campaign.allow_feedback_client) {
          this.$store.commit("finishedInteraction");
          this.$router.replace("/survey");
        } else {
          this.$store.commit("noStartedInteraction");
          this.$router.replace("/form");
        }
      } else {
        this.showTextInput = false;
        this.showEndConv = false;
      }
    },
    openEndConvModal: function openEndConvModal() {
      return this.showEndConv = true;
    }
  }

});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chronometer',
  data: function data() {
    return {
      callSecondsCounter: { 'hours': 0, 'minutes': 0, 'seconds': '00' }
    };
  },


  computed: {
    chronometer: function chronometer() {
      if (this.callSecondsCounter.hours) {
        return ' ' + this.callSecondsCounter.hours + ':' + this.callSecondsCounter.minutes + ':' + this.callSecondsCounter.seconds;
      }
      return ' ' + this.callSecondsCounter.minutes + ':' + this.callSecondsCounter.seconds;
    }
  },

  mounted: function mounted() {
    var _this = this;

    setInterval(function () {
      return _this.timeCounter();
    }, 1000);
  },


  methods: {
    timeCounter: function timeCounter() {
      var callTimeCounter = this.callSecondsCounter;
      if (Number(callTimeCounter.seconds) < 59) {
        this.callSecondsCounter.seconds++;
        if (callTimeCounter.seconds < 10) {
          this.callSecondsCounter.seconds = '0' + this.callSecondsCounter.seconds;
        }
      } else {
        if (callTimeCounter.minutes < 59) {
          this.callSecondsCounter.minutes++;
          this.callSecondsCounter.seconds = 0;
        } else {
          this.callSecondsCounter.hours++;
          this.callSecondsCounter.minutes = 0;
        }
      }
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_utils__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: { show: Boolean,
    messageDialogue: String
  },
  name: 'closing-dialog',
  data: function data() {
    return {
      dialog: false
    };
  },


  methods: {
    invertColor: __WEBPACK_IMPORTED_MODULE_0__assets_utils__["c" /* invertColor */],

    cancelClosing: function cancelClosing() {
      this.$emit("cancelClosingEv", false);
    },
    confirmClosing: function confirmClosing() {
      this.$emit("confirmClosingEv", true);
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_utils__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "main-form",
  data: function data() {
    return {
      client: {
        name: "",
        mail: "",
        number: "",
        message: "",
        initialMessage: ""
      },
      emailRegex: new RegExp(/\S+@\S+\.\S+/),
      messageSended: false,
      errorCheck: false
    };
  },


  computed: {
    getVisibleForm: function getVisibleForm() {
      var campaign = this.$store.state.campaign;

      if (campaign.onTime && campaign.avaiableAgents && campaign.avaiableInteractions) return true;else return campaign.showMessage;
    }
  },

  created: function created() {
    this.$store.commit("changeImage", "");
    this.getInitialInfo();
  },
  mounted: function mounted() {
    this.$store.commit("noStartedInteraction");
    this.$store.commit("newGuid");
    this.$store.commit("clearInitialMessage");
    this.$store.commit("clearInteraction");
  },


  methods: {
    invertColor: __WEBPACK_IMPORTED_MODULE_2__assets_utils__["c" /* invertColor */],

    getInitialInfo: function getInitialInfo() {
      var client = this.$store.state.client;
      this.client.name = client.name;
      this.client.number = client.number;

      if (client.mail.indexOf("no-domain") == -1) {
        this.client.mail = client.mail;
      }
    },
    clickForm: function clickForm() {
      var campaign = this.$store.state.campaign;
      var _client = this.client,
          name = _client.name,
          initialMessage = _client.initialMessage,
          mail = _client.mail,
          number = _client.number;

      var pattern = new RegExp("^([a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ0-9_.@ -])+$");

      if (name && pattern.test(name) && initialMessage && (!number || pattern.test(number))) {
        if (campaign.show_email && mail && pattern.test(mail) && this.emailRegex.test(mail) || !campaign.show_email) {
          if (campaign.custom_field.required && number || !campaign.custom_field.required) {
            if (campaign.onTime && campaign.available) {
              if (!campaign.show_email) {
                this.client.mail = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_utils__["g" /* generateUUID */])() + "@no-domain.com";
              }
              this.sendTochat();
            } else {
              this.sendMessageOffline();
            }
          } else {
            this.$toast.bottom(this.$t('fieldserror'));
            this.errorCheck = true;
          }
        } else {
          this.errorCheck = true;
          this.$toast.bottom(this.$t('emailerror'));
        }
      } else {
        this.$toast.bottom(this.$t('fieldserror'));
        this.errorCheck = true;
      }
    },
    sendMessageOffline: function sendMessageOffline() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.messageSended) {
                  _context.next = 13;
                  break;
                }

                _this.messageSended = true;
                _this.client.campaign = _this.$store.state.configuration.campaign;
                _context.prev = 3;
                _context.next = 6;
                return _this.$http.get("https://" + _this.$store.state.configuration.ip + "/IntegraChannels/resources/webchat/sendOfflineMessage", { params: _this.client });

              case 6:
                _this.$toast.bottom(_this.$t("messagesended"));
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](3);

                _this.$toast.bottom(_this.$t("messageserror"));
                console.log(_context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 9]]);
      }))();
    },
    sendTochat: function sendTochat(e) {
      this.$store.commit("setClientInfo", this.client);
      this.$store.commit("newGuid");
      this.$router.replace("chat");
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attachments__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attachments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__attachments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messageMenu__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messageMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__messageMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messageSurvey__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messageSurvey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__messageSurvey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__messageSurveyYesNo__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__messageSurveyYesNo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__messageSurveyYesNo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_linkify__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_linkify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_linkify__);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: { message: Object, visible: Boolean },
  components: { Attachments: __WEBPACK_IMPORTED_MODULE_1__attachments___default.a, MessageMenu: __WEBPACK_IMPORTED_MODULE_3__messageMenu___default.a, MessageSurvey: __WEBPACK_IMPORTED_MODULE_4__messageSurvey___default.a, MessageSurveyYesNo: __WEBPACK_IMPORTED_MODULE_5__messageSurveyYesNo___default.a },
  name: "message",

  data: function data() {
    return {};
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])([]),
  directives: {
    linkify: __WEBPACK_IMPORTED_MODULE_6_vue_linkify___default.a
  },
  created: function created() {
    if (this.menuMessage(this.message.message)) {
      this.$emit('menuMessage', this);
    }
    if (this.surveyMessage(this.message.message)) {
      this.$emit('surveyMessage', this);
    }
  },

  methods: {
    disableMenuMessage: function disableMenuMessage(message) {
      if (this.$refs.menuMessage) {
        this.$refs.menuMessage.disableMenuMessage(message);
      }
    },

    invertColor: __WEBPACK_IMPORTED_MODULE_2__assets_utils__["c" /* invertColor */],
    menuMessage: function menuMessage(message) {
      return message.split("\n").every(function (text) {
        return text.match(new RegExp("[0-9]+ *- *[^]*", "imy")) != null;
      });
    },
    getEnters: function getEnters(message) {
      var msgWithEnters = message.split(String.fromCharCode(10));
      return msgWithEnters;
    },
    surveyMessage: function surveyMessage(message) {
      if (message) {
        var m = message.split("\n");
        if (m[0] == "(faces)" || m[0] == "(yes/no)") {
          m.shift();
          return m.every(function (text) {
            return text.match(new RegExp("[0-9]+ *- *[^]*", "imy")) != null;
          });
        }
        return false;
      }
    },
    isFaces: function isFaces(message) {
      if (message) {
        var m = message.split("\n");
        return m[0] == "(faces)";
      }
      return false;
    },
    isYesNo: function isYesNo(message) {
      if (message) {
        var m = message.split("\n");
        return m[0] == "(yes/no)";
      }
      return false;
    }
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_utils__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: { message: Object },
  name: "messageMenu",
  components: {},
  computed: {},
  methods: {
    disableMenuMessage: function disableMenuMessage(message) {
      this.message.optionClicked = message;
      this.optionClicked = message;
    },
    sendMessage: function sendMessage(message, index) {
      if (!this.message.optionClicked) {
        this.message.optionClicked = message;
        this.optionClicked = message;
        this.$eventManagerMenu.sendMessage(message);
        this.$store.commit("updateMessage", this.message);
      }
    },
    getObjectMenu: function getObjectMenu(message) {
      var msg = message.split(/(\d+ *\- *)/g);
      msg = msg.filter(function (item) {
        return item;
      });
      var arr = [];
      for (var i = 0; i < msg.length; i++) {
        if (msg[i].match(/(\d+ *\- *)/g)) {
          arr.push(msg[i].trim());
        } else {
          var e = arr.pop();
          e = e + msg[i].trim();
          arr.push(e);
        }
      }

      return arr.map(function (m) {
        var item = {};
        item.option = parseInt(m.split(/\-/)[0].replace("-", "").trim());
        item.optionName = m.split(/\-/)[1];
        item.optionName = item.optionName.split(String.fromCharCode(10));
        item.optionName = item.optionName.filter(function (item) {
          return item;
        });

        item.optionName[0] = item.option + " - " + item.optionName[0];
        return item;
      });
    },

    invertColor: __WEBPACK_IMPORTED_MODULE_0__assets_utils__["c" /* invertColor */]
  },
  created: function created() {
    this.optionClicked = this.message.optionClicked;
  },
  data: function data() {
    return {
      optionClicked: false
    };
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_surveyEmoji1_svg__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_surveyEmoji1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_surveyEmoji1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_surveyEmoji2_svg__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_surveyEmoji2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_surveyEmoji2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_surveyEmoji3_svg__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_surveyEmoji3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_surveyEmoji3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_surveyEmoji4_svg__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_surveyEmoji4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_surveyEmoji4_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_surveyEmoji5_svg__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_surveyEmoji5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_surveyEmoji5_svg__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: { message: Object },
  name: "messageSurvey",
  components: {},
  computed: {},
  methods: {
    disableMenuMessage: function disableMenuMessage(message) {
      this.message.optionClicked = message;
      this.optionClicked = message;
    },
    sendMessage: function sendMessage(message) {
      if (!this.message.optionClicked) {
        this.message.optionClicked = message;
        this.optionClicked = message;
        this.$eventManagerMenu.sendMessage(message);
        this.$store.commit("updateMessage", this.message);
      }
    },
    getObjectMenu: function getObjectMenu(message) {
      var m = message.substring(8);

      var msg = m.split(/(\d+ *\- *)/g);
      msg = msg.filter(function (item) {
        return item;
      });
      var arr = [];
      for (var i = 0; i < msg.length; i++) {
        if (msg[i].match(/(\d+ *\- *)/g)) {
          arr.push(msg[i].trim());
        } else {
          var e = arr.pop();
          e = e + msg[i].trim();
          arr.push(e);
        }
      }

      return arr.map(function (m) {
        var item = {};
        item.option = parseInt(m.split(/\-/)[0].replace("-", "").trim());
        item.optionName = m.split(/\-/)[1];
        item.optionName = item.optionName.split(String.fromCharCode(10));
        item.optionName = item.optionName.filter(function (item) {
          return item;
        });

        item.optionName[0] = item.optionName[0];

        return item;
      });
    },

    invertColor: __WEBPACK_IMPORTED_MODULE_0__assets_utils__["c" /* invertColor */]
  },
  created: function created() {
    this.optionClicked = this.message.optionClicked;
  },
  data: function data() {
    return {
      optionClicked: false,
      avatar1: __WEBPACK_IMPORTED_MODULE_1__assets_surveyEmoji1_svg___default.a,
      avatar2: __WEBPACK_IMPORTED_MODULE_2__assets_surveyEmoji2_svg___default.a,
      avatar3: __WEBPACK_IMPORTED_MODULE_3__assets_surveyEmoji3_svg___default.a,
      avatar4: __WEBPACK_IMPORTED_MODULE_4__assets_surveyEmoji4_svg___default.a,
      avatar5: __WEBPACK_IMPORTED_MODULE_5__assets_surveyEmoji5_svg___default.a
    };
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_surveyYes_svg__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_surveyYes_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_surveyYes_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_surveyNo_svg__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_surveyNo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_surveyNo_svg__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: { message: Object },
  name: "messageSurveyYesNo",
  components: {},
  computed: {},
  methods: {
    disableMenuMessage: function disableMenuMessage(message) {
      this.message.optionClicked = message;
      this.optionClicked = message;
    },
    sendMessage: function sendMessage(message) {
      if (!this.message.optionClicked) {
        this.message.optionClicked = message;
        this.optionClicked = message;
        this.$eventManagerMenu.sendMessage(message);
        this.$store.commit("updateMessage", this.message);
      }
    },
    getObjectMenu: function getObjectMenu(message) {
      var m = message.substring(9);

      var msg = m.split(/(\d+ *\- *)/g);
      msg = msg.filter(function (item) {
        return item;
      });
      var arr = [];
      for (var i = 0; i < msg.length; i++) {
        if (msg[i].match(/(\d+ *\- *)/g)) {
          arr.push(msg[i].trim());
        } else {
          var e = arr.pop();
          e = e + msg[i].trim();
          arr.push(e);
        }
      }

      return arr.map(function (m) {
        var item = {};
        item.option = parseInt(m.split(/\-/)[0].replace("-", "").trim());
        item.optionName = m.split(/\-/)[1];
        item.optionName = item.optionName.split(String.fromCharCode(10));
        item.optionName = item.optionName.filter(function (item) {
          return item;
        });

        item.optionName[0] = item.optionName[0];

        return item;
      });
    },

    invertColor: __WEBPACK_IMPORTED_MODULE_0__assets_utils__["c" /* invertColor */]
  },
  created: function created() {
    this.optionClicked = this.message.optionClicked;
  },
  data: function data() {
    return {
      optionClicked: false,
      yes: __WEBPACK_IMPORTED_MODULE_1__assets_surveyYes_svg___default.a,
      no: __WEBPACK_IMPORTED_MODULE_2__assets_surveyNo_svg___default.a
    };
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_utils__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: { show: Boolean },
  name: 'screen-share-dialog',
  data: function data() {
    return {
      dialog: false
    };
  },


  methods: {
    invertColor: __WEBPACK_IMPORTED_MODULE_0__assets_utils__["c" /* invertColor */],

    no: function no() {
      this.$emit("no", false);
    },
    yes: function yes() {
      this.$emit("yes", true);
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'survey',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },

  data: function data() {
    return {};
  },


  computed: {
    rating: {
      get: function get() {
        return this.$store.state.client.rating;
      },
      set: function set(value) {
        this.$store.commit('setRatingValue', value);
      }
    },

    surveyMessage: {
      get: function get() {
        return this.$store.state.client.surveyMessage;
      },
      set: function set(value) {
        this.$store.commit('setSurveyMessage', value);
      }
    },

    sendmail: {
      get: function get() {
        return this.$store.state.client.sendmail;
      },
      set: function set(value) {
        this.$store.commit('setSendMail', value);
      }
    },

    getTitleMessage: function getTitleMessage() {
      var title = this.$store.state.campaign.feedback;
      var lang = this.$store.state.client.lang;
      return title[lang];
    }
  },

  mounted: function mounted() {
    this.$store.commit('clearSurveyMessage');
    this.$store.commit('clearCalification');
  },


  methods: {
    invertColor: __WEBPACK_IMPORTED_MODULE_2__assets_utils__["c" /* invertColor */],
    clickSend: function clickSend() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.rating) {
                  _context.next = 14;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return _this.$http.get('https://' + _this.$store.state.configuration.ip + '/IntegraChannels/resources/webchat/rating', {
                  params: {
                    guid: _this.$store.state.interaction.guid,
                    rating: _this.$store.state.client.rating * (_this.$store.state.campaign.fullStars == 0 ? 2 : 1),
                    comments: _this.$store.state.client.surveyMessage,
                    mail: _this.$store.state.client.sendmail ? 1 : 0,
                    from: _this.$store.state.client.mail
                  }
                });

              case 4:
                _this.$store.commit('noStartedInteraction');
                _this.$router.replace('/');
                window.parent.postMessage({ action: 'SURVEYCOMPLETED' }, "*");
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                console.warn('ERROR SENDING REQUEST => ', _context.t0);

              case 12:
                _context.next = 15;
                break;

              case 14:
                _this.$toast.bottom(_this.$t('youmustpickastar'));

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 9]]);
      }))();
    },
    minimizeWindow: function minimizeWindow() {
      window.parent.postMessage({ action: 'MINIMIZE' }, "*");
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_utils__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "welcome-message",
  data: function data() {
    return {};
  },


  computed: {
    getText: function getText() {
      var campaign = this.$store.state.campaign;
      var lang = this.$store.state.client.lang;
      var text = "";

      if (campaign.timeOut) {
        text = campaign.notavailablemessage[lang] ? campaign.notavailablemessage[lang] : campaign.notavailablemessage['en'];
      } else {
        if (campaign.onTime) {
          if (campaign.available) {
            text = campaign.welcome[lang] ? campaign.welcome[lang] : campaign.welcome['en'];
          } else {
            text = campaign.notavailablemessage[lang] ? campaign.notavailablemessage[lang] : campaign.notavailablemessage['en'];
          }
        } else {
          if (campaign.outoftime) {
            text = campaign.outoftime[lang] ? campaign.outoftime[lang] : campaign.outoftime['en'];
          }
        }
      }

      return text;
    }
  },

  methods: {
    invertColor: __WEBPACK_IMPORTED_MODULE_0__assets_utils__["c" /* invertColor */],

    minimizeWindow: function minimizeWindow() {
      window.parent.postMessage({ action: 'MINIMIZE' }, "*");
    }
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(17);




var _class = function () {
  function _class(http) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.http = http;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'addAttachment',
    value: function addAttachment(file, func) {
      var _this = this;

      this.convertirB64(file, function (b64) {
        _this.http.post('https://' + __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.configuration.ip + '/IntegraChannels/resources/webchat/addAttachment', b64, {
          headers: {
            'Content-type': 'application/x-www-form-urlencoded'
          },
          params: {
            filename: file.name
          }
        }).then(function (e) {
          if (e.status === 200) {
            func(_this.getFileType(file) + '|' + JSON.parse(e.bodyText)[0]);
          }
        }, function (e) {});
      });
    }
  }, {
    key: 'getFileType',
    value: function getFileType(file) {
      var type = file.type;
      if (type.indexOf('image') > -1) return 'image';else return type.split('/')[0];
    }
  }, {
    key: 'convertirB64',
    value: function convertirB64(archivo, funcion) {
      var _this2 = this;

      var reader = new FileReader();
      reader.onload = function (readerEvt) {
        var b64 = btoa(readerEvt.target.result);
        funcion(_this2.checkB64(b64));
      };
      reader.readAsBinaryString(archivo);
    }
  }, {
    key: 'checkB64',
    value: function checkB64(b64) {
      var menor = 0;
      if (b64.length % 4 != 0) menor = 4 - b64.length % 4;
      for (var i = 0; i < menor; i++) {
        b64 += "=";
      }
      return b64;
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(17);




var _class = function () {
  function _class(http) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.http = http;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'newState',
    value: function newState(ontime, avaiableagents, avaiablesize) {
      var state = 0;
      if (ontime) {
        if (!avaiableagents) state = 1;else if (!avaiablesize) state = 2;else state = 3;
      }

      var savedstate = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.eventState;

      if (state !== savedstate) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setEventState', state);

        if (state !== 3) {
          this.sendEvent(state);
        }
      }
    }
  }, {
    key: 'sendEvent',
    value: function sendEvent(state) {
      this.http.get('https://' + __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.configuration.ip + '/IntegraChannels/resources/webchat/sendEventLog', {
        params: {
          type: state,
          campaign: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.configuration.campaign,
          email: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.mail,
          name: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.name
        }
      }).then(function (e) {
        console.log(e);
      }, function (e) {
        console.log(e);
      });
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_detectrtc__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_detectrtc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_detectrtc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);






var Peer = __webpack_require__(366);



var ScreenShareController = function () {
    function ScreenShareController(sendMessage, showWebrtcStream, isMobile) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ScreenShareController);

        this.sendMessage = sendMessage;
        this.showWebrtcStream = showWebrtcStream;
        this.active = false;
        this.isMobile = isMobile;
        __WEBPACK_IMPORTED_MODULE_5_detectrtc___default.a.load();
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ScreenShareController, [{
        key: 'onMessage',
        value: function onMessage(msj) {

            if (msj.subtype === __WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* default */].WS_REQUEST_SCREEN) {
                if (this.isMobile) {
                    this.sendError(__WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* default */].WS_NOT_SUPPORTED);
                } else if (!this.active) {
                    this.showWebrtcStream.dialog = true;
                }
            } else if (msj.subtype === __WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* default */].WS_SIGNALLING) {
                if (!this.peer) {
                    this.initPeer(false);
                    this.peer.signal(msj.content);
                } else {
                    this.peer.signal(msj.content);
                }
            }
        }
    }, {
        key: 'cancelShareScreen',
        value: function cancelShareScreen() {
            this.showWebrtcStream.dialog = false;
            this.sendError(__WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* default */].WS_DENIED);
        }
    }, {
        key: 'shareScreen',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var stream;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.showWebrtcStream.dialog = false;
                                this.active = true;
                                _context.next = 4;
                                return this.getDisplayMedia();

                            case 4:
                                stream = _context.sent;

                                if (stream) {
                                    this.initPeer(true, stream);
                                } else {
                                    this.active = false;
                                    this.sendError(__WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* default */].WS_DENIED);
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function shareScreen() {
                return _ref.apply(this, arguments);
            }

            return shareScreen;
        }()
    }, {
        key: 'sendError',
        value: function sendError(err) {
            var msj = {
                type: "webchat",
                subtype: __WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* default */].WS_REQUEST_SCREEN,
                content: err,
                source: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.client.guid,
                guid: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.interaction.guid
            };

            this.sendMessage(msj);
        }
    }, {
        key: 'getDisplayMedia',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return navigator.mediaDevices.getDisplayMedia({ video: true });

                            case 3:
                                this.stream = _context2.sent;
                                _context2.next = 10;
                                break;

                            case 6:
                                _context2.prev = 6;
                                _context2.t0 = _context2['catch'](0);

                                this.stream = null;
                                console.error(_context2.t0);

                            case 10:
                                return _context2.abrupt('return', this.stream);

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 6]]);
            }));

            function getDisplayMedia() {
                return _ref2.apply(this, arguments);
            }

            return getDisplayMedia;
        }()
    }, {
        key: 'initPeer',
        value: function initPeer(initiator, stream) {
            var _this = this;

            this.peer = new Peer({
                initiator: initiator, stream: stream, config: {
                    iceServers: [{
                        urls: ["turn:turn-sa.ucontactcloud.com:443", "stun:stun.l.google.com:19302", "stun:stun.ucontactcloud.com"],
                        username: "uc0nt4ct",
                        credential: "IntegraV1d30"
                    }]
                }
            });
            this.peer.on('signal', function (data) {
                _this.sendMessage({
                    type: "webchat",
                    subtype: __WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* default */].WS_SIGNALLING,
                    content: data,
                    source: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.client.guid,
                    guid: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.interaction.guid
                });
            });

            this.peer.on('stream', function (stream) {
                _this.showWebrtcStream.visible = true;
                _this.showWebrtcStream.stream = stream;
            });

            this.peer.on('close', function () {
                _this.onCloseConnection();
            });

            this.peer.on('error', function (err) {
                _this.onCloseConnection();
                console.log(err);
            });

            if (stream) {
                stream.getVideoTracks()[0].onended = function () {
                    _this.closeStream();
                };
            }
        }
    }, {
        key: 'onCloseConnection',
        value: function onCloseConnection() {
            this.showWebrtcStream.visible = false;
            this.active = false;
            this.peer = null;
            if (this.stream) this.stream.getTracks().forEach(function (track) {
                track.stop();
            });
        }
    }, {
        key: 'closeStream',
        value: function closeStream() {
            if (this.peer) this.peer.destroy();
        }
    }]);

    return ScreenShareController;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScreenShareController);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jssip__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jssip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jssip__);




var _class = function () {
  function _class(telServer, campaign, guid, stunTurnConfs, __endcall) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.ua = null;
    this.line1 = null;
    this.remoteView = undefined;
    this.selfView = undefined;
    this.__endcall = __endcall;

    this.campaign = campaign;

    this.telserver = telServer;
    this.guid = guid;
    this.mynumber = "web";
    this.mypassword = "uC0nt4ctW3bch4t";
    this.voice = true;

    this.stunTurnConfs = stunTurnConfs;

    if (navigator.userAgent.indexOf("Chrome") != -1) {
      this.voice = "{ mandatory : { googEchoCancellation: true, googEchoCancellation2: true, googAutoGainControl: true, googNoiseSuppression: true, googHighpassFilter: true, googTypingNoiseDetection: true } }";
    }

    this.socket = new __WEBPACK_IMPORTED_MODULE_2_jssip___default.a.WebSocketInterface("wss://" + this.telserver + ":8089/ws");

    this.configuration = {
      sockets: [this.socket],
      uri: "sip:" + this.mynumber + "@" + this.telserver,
      password: this.mypassword,
      session_timers: false,
      realm: "asterisk",
      register: false
    };

    window.onbeforeunload = function (event) {
      _this.hangUp();
      return null;
    };
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: "setVideoElements",
    value: function setVideoElements(me, agent, store) {
      this.selfView = me;
      this.remoteView = agent;
      this.store = store;
    }
  }, {
    key: "startUA",
    value: function startUA() {
      if (this.ua === null) {
        this.ua = new __WEBPACK_IMPORTED_MODULE_2_jssip___default.a.UA(this.configuration);
        this.ua.start();
        this.attachUAEventHandlers();
      }
    }
  }, {
    key: "attachUAEventHandlers",
    value: function attachUAEventHandlers() {
      var _this2 = this;

      this.ua.on("registered", function (data) {});
      this.ua.on("connecting", function (data) {});
      this.ua.on("connected", function (data) {});
      this.ua.on("disconnected", function (data) {});
      this.ua.on("unregistered", function (data) {});
      this.ua.on("registrationFailed", function (data) {});
      this.ua.on("newMessage", function (data) {});
      this.ua.on("newRTCSession", function (data) {
        _this2.line1 = data.session;
        _this2.attachCallEventHandlers();
      });
    }
  }, {
    key: "attachCallEventHandlers",
    value: function attachCallEventHandlers() {
      var _this3 = this;

      var myCandidateTimeout = null;

      this.line1.on('icecandidate', function (candidate, ready) {
        if (myCandidateTimeout != null) clearTimeout(myCandidateTimeout);

        myCandidateTimeout = setTimeout(candidate.ready, 3000);
      });

      this.line1.on("connecting", function (data) {
        _this3.attachRTCHandlers();
      });

      this.line1.on("confirmed", function (data) {
        console.log("confirmed");
        _this3.chat.sendStartCallEvent(_this3.video);
      });

      var end = this.__endcall;
      this.line1.on("ended", function (data) {
        if (typeof data.message !== "undefined" && data.message !== null) {
          if (typeof data.message.headers !== "undefined" && data.message.headers !== null) {
            if (typeof data.message.headers["X-Asterisk-Hangupcausecode"] !== "undefined" && data.message.headers["X-Asterisk-Hangupcausecode"] !== null) {
              if (typeof data.message.headers["X-Asterisk-Hangupcausecode"][0].raw !== "undefined" && data.message.headers["X-Asterisk-Hangupcausecode"][0].raw !== null) {
                if (typeof data.message.headers["X-Asterisk-Hangupcausecode"][0].raw !== "undefined" && data.message.headers["X-Asterisk-Hangupcausecode"][0].raw === 19) {}
              }
            }
          }
        }

        _this3.chat.sendEndCallEvent(_this3.video);

        _this3.line1 = null;
        _this3.audio = false;
        _this3.video = false;

        end();
      });

      this.line1.on("failed", function (data) {
        _this3.line1 = null;
        _this3.audio = false;
        _this3.emptyVideo();
        _this3.video = false;

        if (data.cause === "Canceled") {}
      });
    }
  }, {
    key: "attachRTCHandlers",
    value: function attachRTCHandlers() {
      var _this4 = this;

      this.line1.connection.onaddstream = function (data) {
        _this4.remoteView.srcObject = data.stream;
      };

      this.line1.connection.onremovestream = function (data) {
        console.log('Removestream...');
      };

      this.line1.connection.ontrack = function (data) {
        _this4.remoteView.srcObject = data.streams[0];
      };

      this.line1.connection.addEventListener("iceconnectionstatechange", function (data) {

        if (data.target.iceConnectionState == 'connected') {

          var localStream = new MediaStream();
          _this4.line1.connection.getSenders().forEach(function (sender) {
            localStream.addTrack(sender.track);
          });

          _this4.selfView.srcObject = localStream;
        }
      });
    }
  }, {
    key: "makeCall",
    value: function makeCall(destination, video) {
      var _this5 = this;

      if (this.ua.status === 1) {
        if (this.line1 == null) {
          this.video = video;

          var options = {
            mediaConstraints: {
              audio: this.voice,
              video: video
            },
            extraHeaders: ["CAMPAIGN: " + this.campaign, "GUID:" + this.guid],
            pcConfig: {
              iceServers: [this.getTurnCredentials()]
            }
          };

          this.ua.call("sip:" + destination + "@" + this.telserver, options);

          this.video = video;
        }
      } else {
        setTimeout(function () {
          _this5.makeCall(destination, video);
        }, 500);
      }
    }
  }, {
    key: "hangUp",
    value: function hangUp() {
      if (this.ua != null) {
        this.ua.terminateSessions();
      }
      this.line1 = null;
    }
  }, {
    key: "SendDTMF",
    value: function SendDTMF(dtmfval) {
      if (this.line1 != null) {
        this.line1.sendDTMF(dtmfval);
      }
    }
  }, {
    key: "mute",
    value: function mute() {
      if (this.line1 != null) {
        this.line1.mute();
      }
    }
  }, {
    key: "unmute",
    value: function unmute() {
      if (this.line1 != null) {
        this.line1.unmute();
      }
    }
  }, {
    key: "emptyVideo",
    value: function emptyVideo() {
      this.remoteView.src = "";
      this.selfView.src = "";
    }
  }, {
    key: "getTurnCredentials",
    value: function getTurnCredentials() {
      var result = void 0;
      if (this.stunTurnConfs.ScreenShareTurn && this.stunTurnConfs.ScreenShareTurnUser && this.stunTurnConfs.ScreenShareTurnPass) {
        result = {
          urls: ["turn:" + this.stunTurnConfs.ScreenShareTurn, "stun:stun.l.google.com:19302", "stun:stun.ucontactcloud.com"],
          username: this.stunTurnConfs.ScreenShareTurnUser,
          credential: this.stunTurnConfs.ScreenShareTurnPass
        };
      } else {
        result = {
          urls: ["stun:stun.l.google.com:19302", "stun:stun.ucontactcloud.com"]
        };
      }
      return result;
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _pleasewait$shareScre;

/* harmony default export */ __webpack_exports__["a"] = (_pleasewait$shareScre = {
    pleasewait: "Please wait to be attended",
    shareScreen: "Would you like to share your screen?",
    no: "না",
    yes: "হ্যা",
    youmustpickastar: "You must pick a calification",
    name: "নাম",
    email: "ইমেইল",
    phone: "ফোন",
    message: "আপনার কথা",
    send: "নতুন কথোপকথন",
    sendpunctuation: "আপনার মতামত",
    musttypemail: "আপনার ইমেইল এড্রেসটি দেয়ার জন্য ধন্যবাদ",
    validemail: "ইমেইল এড্রেসটি সঠিক নয়",
    musttypename: "আপনার নাম দেয়ার জন্য ধন্যবাদ",
    musttypemessage: "আপনার মতামত বা জিজ্ঞাসা আমাদের জানান",
    configuration: "কনফিগারেশন",
    notifications: "নোটিফিকেশন",
    notificationDetails: "নতুন কথোপকথনগুলো আমাকে জানানো হোক",
    close: "শেষ",
    cancel: "বাদ",
    save: "সেভ করুন",
    willclose: "কথোপকথন শেষ",
    closeconf: "কথোপকথন শেষ হলে আবার কন্ফার্ম করুন",
    newmessage: "নতুন কথোপকথন",
    typehere: "আপনার কথা",
    whatdoyouthink: "আমাদের চ্যাট সার্ভিসটি আপনার কেমন লাগলো?",
    sendbymail: "কথোপকথনটি ইমেইলে পাঠিয়ে দিন",
    holdtimeavg: "অ্যাভারেজ হোল্ড টাইম",
    holdtime: "আপনার হোল্ড টাইম",
    messagesended: "আপনার কথা পাঠানো হয়েছে",
    emailerror: "দয়া করে সঠিক ইমেইল এড্রেস দিন",
    messageserror: "সাময়িক অসুবিধার জন্য আন্তরিক দুঃখিত :("
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "message", "আপনার কথা"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "transfering", "অনুগ্রহ করে অপেক্ষা করুন"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "endchat", "কথোপকথন শেষ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "videocall", "ভিডিও কল"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "call", "কল"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "openinextarnalwindow", "নতুন উইন্ডো"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "calling", "কল……"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "callingduration", "কলের সময়"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "mute", "সাউন্ড বন্ধ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "allowmicrophone", "মাইক্রোফোন ব্যবহারে অনুমতি দিন"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "hangup", "কথোপকথন শেষ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "duration", "সময় "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "write", "লিখুন"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "survey_title", 'আশা করছি আমাদের সার্ভিসে আপনি আনন্দিত।'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "survey_desc", "আমাদের চ্যাট সার্ভিস সম্পর্কে আপনার মতামত অত্যন্ত গুরুত্বপূর্ণ। অনুগ্রহ করে আপনার মতামত এখন অথবা পরবর্তীতে জানান।"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "available", "Available"), _pleasewait$shareScre);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _pleasewait$shareScre;

/* harmony default export */ __webpack_exports__["a"] = (_pleasewait$shareScre = {
    pleasewait: "Please wait to be attended",
    shareScreen: "Would you like to share your screen?",
    no: "No",
    yes: "Yes",
    youmustpickastar: "You must pick a calification",
    name: "Name",
    email: "E-mail",
    phone: "Phone",
    message: "Message",
    send: "New conversation",
    sendpunctuation: "Send Feedback",
    musttypemail: "You must type your mail",
    validemail: "This is not a valid E-mail",
    screenshare: "Share Screen",
    musttypename: "You must type your name",
    musttypemessage: "You must type a message",
    configuration: "Configuration",
    notifications: "Notifications",
    notificationDetails: "Notify me about new messages that I recive in this chat",
    close: "Close",
    cancel: "Cancel",
    save: "Save",
    willclose: "Closing Chat",
    closeconf: "Are you sure you want to close the chat ?",
    conversationend: "The conversations has ended, Do you want to close it?",
    newmessage: "New message",
    typehere: "Send a message...",
    whatdoyouthink: "What do you think about the service you have received ?",
    sendbymail: "Send conversation by e-mail",
    holdtimeavg: "Hold time average",
    holdtime: "Your hold time",
    messagesended: "Message Sent!",
    emailerror: "Please enter a valid e-mail to continue",
    fieldserror: "Please check the fields and try again",
    messageserror: "Oops, something went wrong :("
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "message", "Write your Message..."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "transfering", "Transfering..."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "endchat", "End chat"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "videocall", "Videocall"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "call", "Call"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "openinextarnalwindow", "Open in external window"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "calling", "Calling"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "callingduration", "Calling duration"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "mute", "Mute"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "allowmicrophone", "Allow microphone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "hangup", "Hangup"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "duration", "Duration "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "write", "Write"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "survey_title", 'We hope you are happy with the service'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "survey_desc", "We'd love to know more about your experience with our support, you think you can take the time to give us some feedback?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "available", "Available"), _pleasewait$shareScre);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _pleasewait$shareScre;

/* harmony default export */ __webpack_exports__["a"] = (_pleasewait$shareScre = {
    pleasewait: "Por favor, espere a ser atendido",
    shareScreen: "¿Le gustaría compartir la pantalla?",
    no: 'No',
    yes: 'Si',
    youmustpickastar: 'Debe elegir una calificación',
    name: 'Nombre',
    email: 'Correo Electrónico',
    phone: 'Teléfono',
    message: 'Mensaje',
    send: 'Nueva conversación',
    sendpunctuation: "Enviar calificación",
    musttypemail: 'Debe ingresar su correo electrónico',
    validemail: 'No es un correo electrónico válido',
    musttypename: 'Debe ingresar su nombre',
    musttypemessage: 'Debe escribir un mensaje',
    configuration: 'Configuración',
    notifications: 'Notificaciones',
    screenshare: "Compartir Pantalla",
    notificationDetails: 'Notificarme sobre nuevos mensajes que reciba en esta conversación',
    close: 'Cerrar',
    cancel: 'Cancelar',
    save: 'Guardar',
    willclose: 'Cerrando Conversación',
    closeconf: '¿Está seguro que quiere cerrar la conversación?',
    conversationend: 'La conversación ha finalizado, ¿Desea cerrarla?',
    newmessage: 'Nuevo mensaje',
    typehere: 'Envía un mensaje ...',
    whatdoyouthink: '¿Qué piensa acerca del servicio brindado?',
    sendbymail: 'Enviar conversación por email',
    holdtimeavg: 'Tiempo promedio de espera',
    holdtime: 'Su tiempo de espera',
    messagesended: 'Mensaje enviado',
    emailerror: "Debe ingresar un correo válido para continuar",
    fieldserror: "Por favor verifique los campos e intente nuevamente",
    messageserror: 'Oops, algo salio mal :('
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "message", 'Escribe tu mensaje...'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "transfering", 'Transfiriendo...'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "endchat", 'Finalizar chat'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "videocall", 'Videollamada'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "call", 'Llamada'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "openinextarnalwindow", 'Abrir en ventana externa'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "calling", 'Llamando'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "callingduration", 'Duración de la llamada'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "mute", 'Mute'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "allowmicrophone", 'Permitir micrófono'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "hangup", 'Colgar'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "duration", 'Duración '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "write", 'Escribir'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "survey_title", 'Esperamos haberte asistido'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "survey_desc", 'Agradecemos que se tome el tiempo para contarnos que piensa del servicio brindado, estos datos nos ayudan a seguir brindandole un servicio óptimo!'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pleasewait$shareScre, "available", "Disponible"), _pleasewait$shareScre);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _shareScreen$no$yes$y;

/* harmony default export */ __webpack_exports__["a"] = (_shareScreen$no$yes$y = {
    shareScreen: "Vai vēlaties koplietot savu ekrānu?",
    no: "Nē",
    yes: "Jā",
    youmustpickastar: "Lūdzu izvēlieties vienu no vērtējumiem",
    name: "Vārds",
    email: "E-pasts",
    phone: "Telefons",
    message: "Ziņa",
    send: "Jauna saruna",
    sendpunctuation: "Nosūtīt atsauksmi",
    musttypemail: "Jums jāievada jūsu e-pasta adrese",
    validemail: "Ievadīta nederīga e-pasta adrese",
    screenshare: "Koplietot ekrānu",
    musttypename: "Jums jāievada jūsu vārds",
    musttypemessage: "Jums jāievada ziņa",
    configuration: "Konfigurācija",
    notifications: "Paziņojumi",
    notificationDetails: "Paziņot par jaunām ziņām šajā sarakstē",
    close: "Aizvērt",
    cancel: "Atcelt",
    save: "Saglabāt",
    willclose: "Tiek aizvērta sarakste",
    closeconf: "Vai tiešām vēlaties aizvērt šo saraksti ?",
    conversationend: "Sarakste ir beigusies, vai vēltaties to aizvērt?",
    newmessage: "Jauna ziņa",
    typehere: "Nosūtīt ziņu...",
    whatdoyouthink: "Kā varat novērtēt saņemto palīdzību ?",
    sendbymail: "Nosūtīt saraksti e-pastā",
    holdtimeavg: "Vidējais gaidīšanas laiks",
    holdtime: "Jūsu gaidīšanas laiks",
    messagesended: "Ziņa nosūtīta!",
    emailerror: "Lūdzu ievadīt derīgu e-pastu, lai turpinātu",
    fieldserror: "Lūdzu pārbaudīt visus aizpildītos laukus un mēģiniet vēlreiz",
    messageserror: "Ups, kaut kas nogāja greizi :("
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "message", "Ievadiet savu ziņu..."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "transfering", "Pārvieno..."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "endchat", "Beigt saraksti"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "videocall", "Videozvans"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "call", "Zvans"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "openinextarnalwindow", "Atvērt atsevišķā logā"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "calling", "Zvana"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "callingduration", "Zvanīšanas ilgums"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "mute", "Izslēgt skaņu"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "allowmicrophone", "Atļaut izmantot mikrofonu"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "hangup", "Beigt zvanu"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "duration", "Ilgums "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "write", "Rakstīt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "survey_title", 'Ceram, ka esat apmierināti ar pakalpojumu'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "survey_desc", "Jūsu viedoklis mums ir svarīgs. Vai veltīsiet nedaudz laika, lai atstātu atsauksmi?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_shareScreen$no$yes$y, "available", "Pieejams"), _shareScreen$no$yes$y);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_resource__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_toast_lib_toast_css__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_toast_lib_toast_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_toast_lib_toast_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_toast__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_EventsManager__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_EventManagerMenu__ = __webpack_require__(227);













__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 305));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$moment = __webpack_require__(0);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$eventsManager = new __WEBPACK_IMPORTED_MODULE_10__assets_EventsManager__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$eventManagerMenu = new __WEBPACK_IMPORTED_MODULE_11__assets_EventManagerMenu__["a" /* default */]();

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue2_toast___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vuetify___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
    i18n: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 82,
	"./af.js": 82,
	"./ar": 89,
	"./ar-dz": 83,
	"./ar-dz.js": 83,
	"./ar-kw": 84,
	"./ar-kw.js": 84,
	"./ar-ly": 85,
	"./ar-ly.js": 85,
	"./ar-ma": 86,
	"./ar-ma.js": 86,
	"./ar-sa": 87,
	"./ar-sa.js": 87,
	"./ar-tn": 88,
	"./ar-tn.js": 88,
	"./ar.js": 89,
	"./az": 90,
	"./az.js": 90,
	"./be": 91,
	"./be.js": 91,
	"./bg": 92,
	"./bg.js": 92,
	"./bm": 93,
	"./bm.js": 93,
	"./bn": 94,
	"./bn.js": 94,
	"./bo": 95,
	"./bo.js": 95,
	"./br": 96,
	"./br.js": 96,
	"./bs": 97,
	"./bs.js": 97,
	"./ca": 98,
	"./ca.js": 98,
	"./cs": 99,
	"./cs.js": 99,
	"./cv": 100,
	"./cv.js": 100,
	"./cy": 101,
	"./cy.js": 101,
	"./da": 102,
	"./da.js": 102,
	"./de": 105,
	"./de-at": 103,
	"./de-at.js": 103,
	"./de-ch": 104,
	"./de-ch.js": 104,
	"./de.js": 105,
	"./dv": 106,
	"./dv.js": 106,
	"./el": 107,
	"./el.js": 107,
	"./en-au": 108,
	"./en-au.js": 108,
	"./en-ca": 109,
	"./en-ca.js": 109,
	"./en-gb": 110,
	"./en-gb.js": 110,
	"./en-ie": 111,
	"./en-ie.js": 111,
	"./en-il": 112,
	"./en-il.js": 112,
	"./en-in": 113,
	"./en-in.js": 113,
	"./en-nz": 114,
	"./en-nz.js": 114,
	"./en-sg": 115,
	"./en-sg.js": 115,
	"./eo": 116,
	"./eo.js": 116,
	"./es": 119,
	"./es-do": 117,
	"./es-do.js": 117,
	"./es-us": 118,
	"./es-us.js": 118,
	"./es.js": 119,
	"./et": 120,
	"./et.js": 120,
	"./eu": 121,
	"./eu.js": 121,
	"./fa": 122,
	"./fa.js": 122,
	"./fi": 123,
	"./fi.js": 123,
	"./fil": 124,
	"./fil.js": 124,
	"./fo": 125,
	"./fo.js": 125,
	"./fr": 128,
	"./fr-ca": 126,
	"./fr-ca.js": 126,
	"./fr-ch": 127,
	"./fr-ch.js": 127,
	"./fr.js": 128,
	"./fy": 129,
	"./fy.js": 129,
	"./ga": 130,
	"./ga.js": 130,
	"./gd": 131,
	"./gd.js": 131,
	"./gl": 132,
	"./gl.js": 132,
	"./gom-deva": 133,
	"./gom-deva.js": 133,
	"./gom-latn": 134,
	"./gom-latn.js": 134,
	"./gu": 135,
	"./gu.js": 135,
	"./he": 136,
	"./he.js": 136,
	"./hi": 137,
	"./hi.js": 137,
	"./hr": 138,
	"./hr.js": 138,
	"./hu": 139,
	"./hu.js": 139,
	"./hy-am": 140,
	"./hy-am.js": 140,
	"./id": 141,
	"./id.js": 141,
	"./is": 142,
	"./is.js": 142,
	"./it": 144,
	"./it-ch": 143,
	"./it-ch.js": 143,
	"./it.js": 144,
	"./ja": 145,
	"./ja.js": 145,
	"./jv": 146,
	"./jv.js": 146,
	"./ka": 147,
	"./ka.js": 147,
	"./kk": 148,
	"./kk.js": 148,
	"./km": 149,
	"./km.js": 149,
	"./kn": 150,
	"./kn.js": 150,
	"./ko": 151,
	"./ko.js": 151,
	"./ku": 152,
	"./ku.js": 152,
	"./ky": 153,
	"./ky.js": 153,
	"./lb": 154,
	"./lb.js": 154,
	"./lo": 155,
	"./lo.js": 155,
	"./lt": 156,
	"./lt.js": 156,
	"./lv": 157,
	"./lv.js": 157,
	"./me": 158,
	"./me.js": 158,
	"./mi": 159,
	"./mi.js": 159,
	"./mk": 160,
	"./mk.js": 160,
	"./ml": 161,
	"./ml.js": 161,
	"./mn": 162,
	"./mn.js": 162,
	"./mr": 163,
	"./mr.js": 163,
	"./ms": 165,
	"./ms-my": 164,
	"./ms-my.js": 164,
	"./ms.js": 165,
	"./mt": 166,
	"./mt.js": 166,
	"./my": 167,
	"./my.js": 167,
	"./nb": 168,
	"./nb.js": 168,
	"./ne": 169,
	"./ne.js": 169,
	"./nl": 171,
	"./nl-be": 170,
	"./nl-be.js": 170,
	"./nl.js": 171,
	"./nn": 172,
	"./nn.js": 172,
	"./oc-lnc": 173,
	"./oc-lnc.js": 173,
	"./pa-in": 174,
	"./pa-in.js": 174,
	"./pl": 175,
	"./pl.js": 175,
	"./pt": 177,
	"./pt-br": 176,
	"./pt-br.js": 176,
	"./pt.js": 177,
	"./ro": 178,
	"./ro.js": 178,
	"./ru": 179,
	"./ru.js": 179,
	"./sd": 180,
	"./sd.js": 180,
	"./se": 181,
	"./se.js": 181,
	"./si": 182,
	"./si.js": 182,
	"./sk": 183,
	"./sk.js": 183,
	"./sl": 184,
	"./sl.js": 184,
	"./sq": 185,
	"./sq.js": 185,
	"./sr": 187,
	"./sr-cyrl": 186,
	"./sr-cyrl.js": 186,
	"./sr.js": 187,
	"./ss": 188,
	"./ss.js": 188,
	"./sv": 189,
	"./sv.js": 189,
	"./sw": 190,
	"./sw.js": 190,
	"./ta": 191,
	"./ta.js": 191,
	"./te": 192,
	"./te.js": 192,
	"./tet": 193,
	"./tet.js": 193,
	"./tg": 194,
	"./tg.js": 194,
	"./th": 195,
	"./th.js": 195,
	"./tl-ph": 196,
	"./tl-ph.js": 196,
	"./tlh": 197,
	"./tlh.js": 197,
	"./tr": 198,
	"./tr.js": 198,
	"./tzl": 199,
	"./tzl.js": 199,
	"./tzm": 201,
	"./tzm-latn": 200,
	"./tzm-latn.js": 200,
	"./tzm.js": 201,
	"./ug-cn": 202,
	"./ug-cn.js": 202,
	"./uk": 203,
	"./uk.js": 203,
	"./ur": 204,
	"./ur.js": 204,
	"./uz": 206,
	"./uz-latn": 205,
	"./uz-latn.js": 205,
	"./uz.js": 206,
	"./vi": 207,
	"./vi.js": 207,
	"./x-pseudo": 208,
	"./x-pseudo.js": 208,
	"./yo": 209,
	"./yo.js": 209,
	"./zh-cn": 210,
	"./zh-cn.js": 210,
	"./zh-hk": 211,
	"./zh-hk.js": 211,
	"./zh-mo": 212,
	"./zh-mo.js": 212,
	"./zh-tw": 213,
	"./zh-tw.js": 213
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 356;

/***/ }),
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chat-background2.c8778d0.svg";

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5Mi43MyA5Mi41Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2UxNzAxZjt9LmNscy0ye2ZpbGw6IzllNDgxODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkNhcml0YXNfPC90aXRsZT48ZyBpZD0iTW9kb19kZV9haXNsYW1pZW50byIgZGF0YS1uYW1lPSJNb2RvIGRlIGFpc2xhbWllbnRvIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik00Ni41Myw5Mi40N0MyMSw5My4wNy0uMzEsNzEuMzgsMCw0NS44OS4zMiwyMC41NywyMS4wNS0uMjUsNDYuNjEsMHM0NiwyMC4yNyw0Ni4xMiw0Ni4wNUM5Mi45MSw3Mi42Miw3MSw5Mi44OCw0Ni41Myw5Mi40N1ptLTEtMzUuMzlhMjMuMTIsMjMuMTIsMCwwLDAtMy42MywwYy01LjM1Ljg5LTEwLjA2LDIuODYtMTIuODMsOC0uMzQuNjMtLjc3LDEuMjQtLjM1LDEuOXMxLjQzLjUyLDIuMTQuMzljMS4yNy0uMjIsMi40OS0uNzUsMy43Ni0uOTEsNi45MS0uOSwxMy44My0xLjUsMjAuNzUsMCwxLjYuMzMsMy4yLjY0LDQuOC45Mi42Ny4xMywxLjQ1LjM1LDEuOTItLjMyYTEuNzEsMS43MSwwLDAsMC0uMjUtMS45NCwxMi4zMSwxMi4zMSwwLDAsMC0xLjIzLTEuNjRDNTYuNjIsNTguOTQsNTEuNjYsNTYuNjQsNDUuNTYsNTcuMDhaTTY4LDM1YTYuNjIsNi42MiwwLDAsMC02LjY3LTYuNDdBNi40OSw2LjQ5LDAsMCwwLDU1LjEsMzVjMCwzLjM3LDMsNi41OSw2LjE5LDYuMzZDNjUuMSw0MS4xMiw2Ny44NSwzOSw2OCwzNVptLTMwLjIuMTNhNi40Nyw2LjQ3LDAsMSwwLTEyLjkyLjMxLDYuNjQsNi42NCwwLDAsMCw2LjUyLDZDMzQuNCw0MS4yOCwzNy45MSwzNy43OSwzNy44NCwzNS4xWiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTQ1LjU1LDU3LjA4YzYuMTEtLjQ0LDExLjA3LDEuODYsMTUuMDksNi4zNmExMi4zMSwxMi4zMSwwLDAsMSwxLjIzLDEuNjRBMS43MSwxLjcxLDAsMCwxLDYyLjEyLDY3Yy0uNDcuNjctMS4yNS40NS0xLjkyLjMyLTEuNi0uMjgtMy4yLS41OS00LjgtLjkyLTYuOTItMS40Ni0xMy44NC0uODYtMjAuNzUsMC0xLjI3LjE2LTIuNDkuNjktMy43Ni45MS0uNzEuMTMtMS42Mi40MS0yLjE0LS4zOXMwLTEuMjcuMzUtMS45YzIuNzctNS4xMSw3LjQ4LTcuMDgsMTIuODMtOEEyMywyMywwLDAsMSw0NS41NSw1Ny4wOFoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik02OCwzNWMtLjE5LDQtMi45NCw2LjE1LTYuNzUsNi40My0zLjE5LjIzLTYuMTQtMy02LjE5LTYuMzZhNi40OSw2LjQ5LDAsMCwxLDYuMjctNi41NEE2LjYyLDYuNjIsMCwwLDEsNjgsMzVaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMzcuODQsMzUuMWMuMDcsMi42OS0zLjQ0LDYuMTgtNi40LDYuMzRhNi42NCw2LjY0LDAsMCwxLTYuNTItNiw2LjQ3LDYuNDcsMCwxLDEsMTIuOTItLjMxWiIvPjwvZz48L3N2Zz4="

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5Mi43MyA5Mi41Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2U5YWYzNjt9LmNscy0ye2ZpbGw6I2E5NzIyNjt9LmNscy0ze2ZpbGw6I2EzNmIyNDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkNhcml0YXNfPC90aXRsZT48ZyBpZD0iTW9kb19kZV9haXNsYW1pZW50byIgZGF0YS1uYW1lPSJNb2RvIGRlIGFpc2xhbWllbnRvIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik00Ni40LDkyLjQ4QTQ1LjkzLDQ1LjkzLDAsMCwxLDAsNDcuMDYsNDYuMDYsNDYuMDYsMCwwLDEsNDYuNjYsMCw0Ni4yMSw0Ni4yMSwwLDAsMSw5Mi43Miw0Ny4zQzkyLjMyLDcxLjkzLDcxLjYzLDkzLDQ2LjQsOTIuNDhabS4yNy0zMy4zMWMtNi45MiwwLTEzLjg0LDAtMjAuNzUsMC0xLjcyLDAtMi41Ny4zNy0yLjQ1LDIuMjguMSwxLjU5LjA1LDIuOTEsMi4yNiwyLjlxMjAuNjItLjA3LDQxLjI1LDBjMi4xNywwLDIuMjUtMS4yMSwyLjMzLTIuODQuMDktMS44NS0uNjItMi4zNy0yLjQtMi4zNEM2MC4xNiw1OS4yMiw1My40Miw1OS4xNyw0Ni42Nyw1OS4xN1pNNjEuODUsMjguNTJjLTQuMjIuMDktNi43MiwyLjY4LTYuNjIsNi44NWE2LjYzLDYuNjMsMCwwLDAsNi4yNyw2LjA2LDcsNywwLDAsMCw2LjY3LTYuODlDNjguMiwzMS41Niw2NC45NCwyOC40Niw2MS44NSwyOC41MlpNMzcuNTMsMzQuNzhhNi4xOSw2LjE5LDAsMCwwLTUuOTItNi4yNiw2LjYyLDYuNjIsMCwwLDAtNyw2LjE1LDYuODMsNi44MywwLDAsMCw2LjQ0LDYuNzZBNi41OCw2LjU4LDAsMCwwLDM3LjUzLDM0Ljc4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTQ2LjY3LDU5LjE3YzYuNzUsMCwxMy40OSwwLDIwLjI0LDAsMS43OCwwLDIuNDkuNDksMi40LDIuMzQtLjA4LDEuNjMtLjE2LDIuODUtMi4zMywyLjg0cS0yMC42My0uMDctNDEuMjUsMGMtMi4yMSwwLTIuMTYtMS4zMS0yLjI2LTIuOS0uMTItMS45MS43My0yLjMsMi40NS0yLjI4QzMyLjgzLDU5LjIyLDM5Ljc1LDU5LjE3LDQ2LjY3LDU5LjE3WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTYxLjg1LDI4LjUyYzMuMDktLjA2LDYuMzUsMyw2LjMyLDZhNyw3LDAsMCwxLTYuNjcsNi44OSw2LjYzLDYuNjMsMCwwLDEtNi4yNy02LjA2QzU1LjEzLDMxLjIsNTcuNjMsMjguNjEsNjEuODUsMjguNTJaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMzcuNTMsMzQuNzhhNi41OCw2LjU4LDAsMCwxLTYuNDYsNi42NSw2LjgzLDYuODMsMCwwLDEtNi40NC02Ljc2LDYuNjIsNi42MiwwLDAsMSw3LTYuMTVBNi4xOSw2LjE5LDAsMCwxLDM3LjUzLDM0Ljc4WiIvPjwvZz48L3N2Zz4="

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5Mi41MSA5Mi41Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6Izc3YzA3OTt9LmNscy0ye2ZpbGw6IzUwODI1MTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkNhcml0YXNfPC90aXRsZT48ZyBpZD0iTW9kb19kZV9haXNsYW1pZW50byIgZGF0YS1uYW1lPSJNb2RvIGRlIGFpc2xhbWllbnRvIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik00Ni4yOCw5Mi40N0E0Ni4yMyw0Ni4yMywwLDEsMSw0NywwLDQ2LjI1LDQ2LjI1LDAsMCwxLDkyLjgsNDYuNzlDOTIuNjcsNzIuMjUsNzEuMzksOTMsNDYuMjgsOTIuNDdabS0uMi0yMS4zNWExNC41MywxNC41MywwLDAsMCw1LjY2LS42YzQuNjctMSw4Ljc3LTMsMTEuMDctNy42MWExLjcxLDEuNzEsMCwwLDAsLjIxLTEuN2MtLjQxLS43MS0xLS4yNi0xLjYxLS4xNmE4MS45Miw4MS45MiwwLDAsMS0yOS41NC4wNWMtLjc1LS4xNC0xLjU0LS42NS0yLjEuMjFzLjE3LDEuNDcuNTYsMi4wOUMzNCw2OS4xNywzOS43NSw3MC43OCw0Ni4wOCw3MS4xMlpNMzcuNjcsMzUuMjNjMC0yLjg3LTMuNTUtNi4xNC02LjY1LTYuMTctMi42MiwwLTYuMjEsMy42NS02LjI1LDYuMzhBNi42LDYuNiwwLDAsMCwzMS4xMiw0MkMzNS4xNiw0MS44NywzNy43MSwzOS4yNCwzNy42NywzNS4yM1ptMjMuODItNS43MmE1LjY2LDUuNjYsMCwwLDAtNi4wOSw1LjlBNi4zMSw2LjMxLDAsMCwwLDYxLjg5LDQyYzMuMjUsMCw2LTMsNi02LjU0QzY3Ljc5LDMxLjc2LDY1LjM5LDI5LjUyLDYxLjQ5LDI5LjUxWiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTQ2LjA4LDcxLjEyYy02LjMzLS4zNC0xMi4wNi0yLTE1Ljc1LTcuNzItLjM5LS42Mi0xLjA5LTEuMjctLjU2LTIuMDlzMS4zNS0uMzUsMi4xLS4yMWE4MS45Miw4MS45MiwwLDAsMCwyOS41NC0uMDVjLjU3LS4xLDEuMi0uNTUsMS42MS4xNmExLjcxLDEuNzEsMCwwLDEtLjIxLDEuN2MtMi4zLDQuNTctNi40LDYuNi0xMS4wNyw3LjYxQTE0LjUzLDE0LjUzLDAsMCwxLDQ2LjA4LDcxLjEyWiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTM3LjY3LDM1LjIzYzAsNC0yLjUxLDYuNjQtNi41NSw2Ljc1YTYuNiw2LjYsMCwwLDEtNi4zNS02LjU0YzAtMi43MywzLjYzLTYuNCw2LjI1LTYuMzhDMzQuMTIsMjkuMDksMzcuNjQsMzIuMzYsMzcuNjcsMzUuMjNaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNjEuNDksMjkuNTFjMy45LDAsNi4zLDIuMjUsNi4zNyw1LjkyLjA2LDMuNS0yLjcyLDYuNTQtNiw2LjU0YTYuMzEsNi4zMSwwLDAsMS02LjQ5LTYuNTZBNS42Niw1LjY2LDAsMCwxLDYxLjQ5LDI5LjUxWiIvPjwvZz48L3N2Zz4="

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5Mi44MiA5Mi41Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzVmOTg2OTt9LmNscy0ye2ZpbGw6IzM5NWI0MTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkNhcml0YXNfPC90aXRsZT48ZyBpZD0iTW9kb19kZV9haXNsYW1pZW50byIgZGF0YS1uYW1lPSJNb2RvIGRlIGFpc2xhbWllbnRvIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik00Ni43LDkyLjQ4QzIxLDkzLjEzLDAsNzEuNDgsMCw0Ni4yNFMyMC44MS4wNyw0NS43OSwwYzI2LjE4LS4wNyw0Ni45LDIwLjM5LDQ3LDQ2LjI0QzkzLDcxLjcsNzEuNzksOTIuOTIsNDYuNyw5Mi40OFptLjE3LTE0LjA2QTMxLDMxLDAsMCwwLDUzLDc3LjY5YTI3LjIzLDI3LjIzLDAsMCwwLDEzLjg4LTkuNEEyMS41NSwyMS41NSwwLDAsMCw3MS43LDU1LjVjMC0xLjUyLS4xOS0yLjEtMi0xLjcyQTEwOC42NiwxMDguNjYsMCwwLDEsNDAuODcsNTZhNzIuMzUsNzIuMzUsMCwwLDEtMTQtMS44QzIxLjIyLDUyLjcsMjEsNTMsMjEuNzIsNTguOEE4LDgsMCwwLDAsMjIsNjAuNThDMjUuODUsNzEsMzQuNjcsNzguMzMsNDYuODcsNzguNDJabS05LjUtNDIuNzdjMC0zLjg0LTIuMjMtNi4xMy02LTYuMTRhNi42NCw2LjY0LDAsMCwwLTYuNDgsNi4zNEE2LjYzLDYuNjMsMCwwLDAsMzEuMzYsNDIsNi4wOSw2LjA5LDAsMCwwLDM3LjM3LDM1LjY1Wm0zMC4xNy0uMDdjMC0zLjY4LTIuMjYtNi01LjgzLTYuMDYtMy4zNCwwLTYuNzIsMy02LjYyLDUuOTIuMSwzLjIxLDMuMjcsNi42Nyw2LjIyLDYuNDhDNjQuODIsNDEuNjksNjcuODIsMzkuODksNjcuNTQsMzUuNThaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNDYuODcsNzguNDJjLTEyLjItLjA5LTIxLTcuNC0yNC44OS0xNy44NGE4LDgsMCwwLDEtLjI2LTEuNzhjLS43Ny01Ljg0LS41LTYuMSw1LjEyLTQuNjJhNzIuMzUsNzIuMzUsMCwwLDAsMTQsMS44LDEwOC42NiwxMDguNjYsMCwwLDAsMjguNzgtMi4yYzEuODYtLjM4LDIuMS4yLDIsMS43MmEyMS41NSwyMS41NSwwLDAsMS00LjgsMTIuNzlBMjcuMjMsMjcuMjMsMCwwLDEsNTMsNzcuNjksMzEsMzEsMCwwLDEsNDYuODcsNzguNDJaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMzcuMzcsMzUuNjVhNi4wOSw2LjA5LDAsMCwxLTYsNi4zMyw2LjYzLDYuNjMsMCwwLDEtNi40Ni02LjEzLDYuNjQsNi42NCwwLDAsMSw2LjQ4LTYuMzRDMzUuMTQsMjkuNTIsMzcuMzgsMzEuODEsMzcuMzcsMzUuNjVaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNjcuNTQsMzUuNThjLjI4LDQuMzEtMi43Miw2LjExLTYuMjMsNi4zNC0zLC4xOS02LjEyLTMuMjctNi4yMi02LjQ4LS4xLTIuOTMsMy4yOC01Ljk1LDYuNjItNS45MkM2NS4yOCwyOS41NSw2Ny41NSwzMS45LDY3LjU0LDM1LjU4WiIvPjwvZz48L3N2Zz4="

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5Mi44MiA5Mi41Ij48ZGVmcz48c3R5bGU+LmNscy0xLC5jbHMtM3tmaWxsOiNkYzRhM2Y7fS5jbHMtMntmaWxsOiMxZDFkMWI7b3BhY2l0eTowLjc7fS5jbHMtM3tzdHJva2U6I2RjNGEzZjtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6Mi42OHB4O308L3N0eWxlPjwvZGVmcz48dGl0bGU+Q2FyaXRhczwvdGl0bGU+PGcgaWQ9Ik1vZG9fZGVfYWlzbGFtaWVudG8iIGRhdGEtbmFtZT0iTW9kbyBkZSBhaXNsYW1pZW50byI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNDYuMTQsOTIuNDhDMjEuNDIsOTIuOS0uMjcsNzIsMCw0NS43NkE0Ni41Myw0Ni41MywwLDAsMSw0Ni41LDBDNzEuNzksMCw5Mi43OCwyMC45LDkyLjgyLDQ2LDkyLjg3LDcyLjIxLDcxLjIxLDkzLjEzLDQ2LjE0LDkyLjQ4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTI0LDQzLjJhOS40Miw5LjQyLDAsMCwwLTEuMzYsNC45NSw4LjYzLDguNjMsMCwwLDAsOC41Miw4LjQ5aDMuNjJhMTIuNzEsMTIuNzEsMCwwLDAtLjg4LDQuNjJjMCw3LjIzLDMuNzQsMTAuNCw5LjQ2LDEwLjQsNi4xMSwwLDUuNzYtOS40Miw3LjEyLTEwLjc4LDIuMjYtMi4yNiw0LjkyLTYuNiw2LjgzLTguMjhoOS44YTMuMTgsMy4xOCwwLDAsMCwzLjE4LTMuMThWMjUuNmEzLjE5LDMuMTksMCwwLDAtMy4xOC0zLjE4SDYwLjcxYTMuMTgsMy4xOCwwLDAsMC0zLjA4LDIuMzhjLTQuNDItLjEtNy40NS00LTE3LjY1LTRoLTIuMmMtNy42NiwwLTExLjEyLDMuOTEtMTEuMjIsOS40NkE5LjYsOS42LDAsMCwwLDI0Ljg0LDM3LDkuMjIsOS4yMiwwLDAsMCwyNCw0My4yWiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTMwLjA4LDM3Ljg2YTQuNDIsNC40MiwwLDAsMSwxLjM4LTUuNzJjLS43Ni00Ljg0LDEuNzUtNi41NCw1LjI4LTYuNTRoMy43NWM3LjExLDAsMTEuNzIsMy43NiwxNywzLjc2VjQ3Ljg0SDU2LjQ1Yy0yLjgyLDAtNi43NSw3LTkuMzksOS42Ny0yLjgxLDIuODItMS44OCw3LjUxLTMuNzUsOS4zOS00LjcsMC00LjctMy4yOC00LjctNS42NCwwLTMuODgsMi44Mi01LjYzLDIuODItOS4zOEgzMS4xMWEzLjg4LDMuODgsMCwwLDEtMy43Ni0zLjc1YzAtMS44OCwxLjI3LTMuNzYsMi4yMS0zLjc2YTQuNzcsNC43NywwLDAsMSwuNTItNi41MVoiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjYyLjE1IiB5PSIyNC43NiIgd2lkdGg9IjUuMzYiIGhlaWdodD0iMjUuNDYiIHJ4PSIxLjYxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjkuNjUgNzQuOTgpIHJvdGF0ZSgxODApIi8+PC9nPjwvc3ZnPg=="

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5Mi44MiA5Mi41Ij48ZGVmcz48c3R5bGU+LmNscy0xLC5jbHMtM3tmaWxsOiM1Zjk4Njk7fS5jbHMtMntmaWxsOiMxZDFkMWI7b3BhY2l0eTowLjc7fS5jbHMtM3tzdHJva2U6IzVmOTg2OTtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6Mi42OHB4O308L3N0eWxlPjwvZGVmcz48dGl0bGU+Q2FyaXRhczwvdGl0bGU+PGcgaWQ9Ik1vZG9fZGVfYWlzbGFtaWVudG8iIGRhdGEtbmFtZT0iTW9kbyBkZSBhaXNsYW1pZW50byI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNDYuNyw5Mi40OEMyMSw5My4xMywwLDcxLjQ4LDAsNDYuMjRTMjAuODEuMDcsNDUuNzksMGMyNi4xOC0uMDcsNDYuOSwyMC4zOSw0Nyw0Ni4yNEM5Myw3MS43LDcxLjc5LDkyLjkyLDQ2LjcsOTIuNDhaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNjguODcsNDkuMjlhOS4zNiw5LjM2LDAsMCwwLDEuMzYtNC45NCw4LjY0LDguNjQsMCwwLDAtOC41Mi04LjVINTguMDlBMTIuNjIsMTIuNjIsMCwwLDAsNTksMzEuMjNjMC03LjIyLTMuNzQtMTAuMzktOS40Ni0xMC4zOS02LjExLDAtNS43Niw5LjQyLTcuMTIsMTAuNzgtMi4yNiwyLjI1LTQuOTIsNi41OS02LjgyLDguMjhIMjUuNzZhMy4xNywzLjE3LDAsMCwwLTMuMTcsMy4xN1Y2Ni45YTMuMTcsMy4xNywwLDAsMCwzLjE3LDMuMTdoNi4zNmEzLjE3LDMuMTcsMCwwLDAsMy4wNy0yLjM4YzQuNDIuMSw3LjQ1LDQsMTcuNjUsNGgyLjIxYzcuNjUsMCwxMS4xMS0zLjkxLDExLjIxLTkuNDZBOS42LDkuNiwwLDAsMCw2OCw1NS41NSw5LjI1LDkuMjUsMCwwLDAsNjguODcsNDkuMjlaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNNjIuNzQsNTQuNjRhNC40LDQuNCwwLDAsMS0xLjM4LDUuNzFjLjc2LDQuODUtMS43NSw2LjU0LTUuMjgsNi41NEg1Mi4zM2MtNy4xMSwwLTExLjcyLTMuNzUtMTctMy43NVY0NC42NmgxLjA5YzIuODEsMCw2Ljc0LTcsOS4zOC05LjY3LDIuODItMi44MiwxLjg4LTcuNTEsMy43NS05LjM5LDQuNywwLDQuNywzLjI3LDQuNyw1LjYzLDAsMy44OS0yLjgyLDUuNjMtMi44Miw5LjM5SDYxLjcxYTMuODcsMy44NywwLDAsMSwzLjc2LDMuNzVjMCwxLjg4LTEuMjcsMy43NS0yLjIxLDMuNzVhNC43OCw0Ljc4LDAsMCwxLS41Miw2LjUyWiIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMjUuMzIiIHk9IjQyLjI4IiB3aWR0aD0iNS4zNiIgaGVpZ2h0PSIyNS40NiIgcng9IjEuNjEiLz48L2c+PC9zdmc+"

/***/ }),
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(310)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(404),
  /* scopeId */
  "data-v-27211e30",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(322)
__webpack_require__(323)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(414),
  /* scopeId */
  "data-v-ebe11a04",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(316)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(408),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(319)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(411),
  /* scopeId */
  "data-v-949db288",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(320)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(412),
  /* scopeId */
  "data-v-a6f61c82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(307)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(402),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(311)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(405),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(306)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(401),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(318)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(410),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(312)
__webpack_require__(313)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(406),
  /* scopeId */
  "data-v-2954ae52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(315)
__webpack_require__(314)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(407),
  /* scopeId */
  "data-v-3b3c0858",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "containerMessage",
    style: ({
      'background-color': 'none'
    })
  }, [_c('ul', {
    staticClass: "ulMessageMenu"
  }, [_c('li', {
    staticClass: "liMessageMenu",
    class: _vm.optionClicked ? 'changeCursor ' + 'notselected' : 'selected',
    style: ({
      'height': '120px !important'
    })
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column",
    style: ({
      'margin-left': '35px'
    })
  }, [_c('a', {
    staticClass: "aSurveyMessage",
    class: _vm.optionClicked ? 'changeCursor' : '',
    on: {
      "click": function($event) {
        _vm.sendMessage(_vm.getObjectMenu(_vm.message.message)[0].option)
      }
    }
  }, [_c('div', {
    staticClass: "faces centrado",
    style: ({
      'background-image': 'url(' + _vm.yes + ')',
      'top': '0px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "centrado",
    style: ({
      'font-size': '10px!important',
      'top': '50px'
    })
  }, [_vm._v(_vm._s(_vm.getObjectMenu(_vm.message.message)[0].optionName[0]))])])]), _vm._v(" "), _c('div', {
    staticClass: "column",
    style: ({
      'margin-left': '60px'
    })
  }, [_c('a', {
    staticClass: "aSurveyMessage",
    class: _vm.optionClicked ? 'changeCursor' : '',
    on: {
      "click": function($event) {
        _vm.sendMessage(_vm.getObjectMenu(_vm.message.message)[1].option)
      }
    }
  }, [_c('div', {
    staticClass: "faces centrado",
    style: ({
      'background-image': 'url(' + _vm.no + ')',
      'top': '0px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "centrado",
    style: ({
      'font-size': '10px!important',
      'top': '50px'
    })
  }, [_vm._v(_vm._s(_vm.getObjectMenu(_vm.message.message)[1].optionName[0]))])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "containerMessage",
    style: ({
      'background-color': 'none'
    })
  }, [_c('ul', {
    staticClass: "ulMessageMenu"
  }, _vm._l((_vm.getObjectMenu(_vm.message.message)), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "liMessageMenu",
      class: _vm.optionClicked ? 'changeCursor ' + (index + 1 !== _vm.optionClicked ? 'notselected' : 'selected') : 'selected',
      style: ({
        'border-color': _vm.$store.state.campaign.color,
        'color': _vm.invertColor(_vm.$store.state.campaign.color, true, true)
      }),
      on: {
        "click": function($event) {
          return _vm.sendMessage(item.option, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left",
        "position": "absolute",
        "top": "6px"
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("\n          keyboard_arrow_right\n          " + _vm._s(item.option) + "\n        ")])]), _vm._v(" "), _vm._l((item.optionName), function(e) {
      return _c('p', {
        key: e.optionName,
        staticClass: "pMessageMenu",
        class: _vm.optionClicked ? 'changeCursor' : '',
        style: ({
          'color': _vm.invertColor(_vm.$store.state.campaign.color, true, true),
          'font-size': '14px',
          'font-family': 'Lato'
        })
      }, [_c('a', {
        class: _vm.optionClicked ? 'changeCursor' : '',
        style: ({
          'color': _vm.invertColor(_vm.$store.state.campaign.color, true, true),
          'font-size': '14px',
          'font-family': 'Lato'
        })
      }, [_vm._v(_vm._s(e))])])
    })], 2)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-chat"
    }
  }, [_c('div', {
    staticClass: "viewContainer"
  }, [(!_vm.$store.getters.isWaitingInteraction) ? _c('div', {
    staticClass: "chatHolder",
    class: {
      'show-chat': _vm.$store.getters.isStartedInteraction
    }
  }, [_c('div', {
    staticClass: "accionIconos"
  }, [_c('chat-toolbar', {
    staticClass: "width-100",
    attrs: {
      "hideEndConv": this.endConv,
      "isBot": this.bot
    },
    on: {
      "openConfirmationModal": _vm.openCloseDialog,
      "clickCallEv": _vm.openWindowCalling,
      "clickVideoCallEv": _vm.openWindowVideocalling
    }
  })], 1), _vm._v(" "), _c('call', {
    ref: "callComponent",
    attrs: {
      "show": _vm.isInCall,
      "video": _vm.isOnVideoCall
    },
    on: {
      "hangupEv": _vm.hangup,
      "hideTextAreaEv": _vm.switchShowTextInput,
      "phone": _vm.onPhone
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWebrtcStream.visible),
      expression: "showWebrtcStream.visible"
    }],
    attrs: {
      "id": "streamContainer"
    }
  }, [_c('v-btn', {
    attrs: {
      "id": "closeStream",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.screenShareController.closeStream()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('video', {
    attrs: {
      "autoplay": "",
      "id": "webrtcstream",
      "width": "300px",
      "height": "300px"
    },
    domProps: {
      "srcObject": _vm.showWebrtcStream.stream
    }
  })], 1), _vm._v(" "), _c('closing-dialog', {
    attrs: {
      "messageDialogue": _vm.$t('closeconf'),
      "show": _vm.showClosingDialog
    },
    on: {
      "confirmClosingEv": _vm.shouldClose,
      "cancelClosingEv": _vm.hideClosingModal
    }
  }), _vm._v(" "), _c('screen-share-dialog', {
    attrs: {
      "show": _vm.showWebrtcStream.dialog
    },
    on: {
      "yes": function($event) {
        return _vm.screenShareController.shareScreen()
      },
      "no": function($event) {
        return _vm.screenShareController.cancelShareScreen()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "holderChat chat-background",
    class: {
      'relative-pos': this.$store.state.isLowRes, 'holderChatWithVideo': _vm.isOnVideoCall
    },
    style: ({
      'background-image': 'url(' + _vm.background + ')'
    })
  }, [_c('ol', {
    ref: "olchat",
    staticClass: "chat",
    class: _vm.isOnVideoCall ? 'chatWithVideo' : '',
    on: {
      "click": function($event) {
        return _vm.$refs.textarea.blur()
      }
    }
  }, [_vm._l((_vm.$store.state.interaction.messages), function(item, index) {
    return _c('message', {
      key: index,
      attrs: {
        "visible": !(index == 0 && _vm.hasParameters()),
        "message": item
      },
      on: {
        "menuMessage": _vm.menuMessageEvent
      }
    })
  }), _vm._v(" "), (_vm.typingVisible) ? _c('message') : _vm._e()], 2), _vm._v(" "), _c('closing-dialog', {
    attrs: {
      "messageDialogue": _vm.$t('conversationend'),
      "show": _vm.showEndConv
    },
    on: {
      "confirmClosingEv": _vm.acceptModalEndConv,
      "cancelClosingEv": _vm.cancelModalEndConv
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTextInput && !this.endConv && !_vm.$store.state.interaction.transfering),
      expression: "showTextInput && !this.endConv && !$store.state.interaction.transfering"
    }],
    staticClass: "containerButtons"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typingText),
      expression: "typingText"
    }],
    ref: "textarea",
    staticClass: "textarea",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('typehere')
    },
    domProps: {
      "value": (_vm.typingText)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendMessage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.typingText = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.$store.getters.hasTextareaText) ? _c('div', {
    staticClass: "btnTextarea"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("send")])], 1)], 1) : (this.$store.state.campaign.allow_attachments) ? _c('div', {
    staticClass: "btnTextarea"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addAttachment($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("attach_file")])], 1), _vm._v(" "), _c('input', {
    ref: "inputfiles",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.isWaitingInteraction) ? _c('v-card', {
    attrs: {
      "id": "holderWaiting"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('div', {
    staticClass: "finishInteractionButton",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showModalAbandon = true
      }
    }
  }, [_c('v-icon', {
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('close')))])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: (_vm.showModalAbandon),
      callback: function($$v) {
        _vm.showModalAbandon = $$v
      },
      expression: "showModalAbandon"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('closeconf')))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "flat"
    },
    on: {
      "click": function($event) {
        return _vm.clickModalAbandon()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('yes')))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "flat"
    },
    on: {
      "click": function($event) {
        _vm.showModalAbandon = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('no')))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "holdTimeText"
  }, [_c('p', [_c('v-icon', {
    staticClass: "rotate"
  }, [_vm._v("cached")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.$t('pleasewait')) + "\n        ")])])], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.files) ? _c('div', {
    staticClass: "attachments-container"
  }, _vm._l((_vm.files), function(item, index) {
    return _c('div', {
      key: index
    }, [(_vm.isImage(item)) ? _c('img', {
      staticClass: "image-attachment",
      attrs: {
        "src": _vm.getSrc(item)
      }
    }) : (_vm.isVideo(item)) ? _c('video', {
      staticClass: "image-attachment",
      attrs: {
        "src": _vm.getSrc(item),
        "autoplay": "",
        "controls": "controls",
        "muted": "muted"
      },
      domProps: {
        "muted": true
      }
    }) : (_vm.isAudio(item)) ? _c('audio', {
      attrs: {
        "controls": "",
        "src": _vm.getSrc(item)
      }
    }) : _c('a', {
      staticClass: "link-attachment",
      attrs: {
        "target": "_blank",
        "href": _vm.getSrc(item)
      }
    }, [_c('i', {
      staticClass: "fa fa-file"
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getNameFile(item))
      }
    })])])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "containerMessage",
    style: ({
      'background-color': 'none',
      'width': '100% !important',
      'max-width': '100%'
    })
  }, [_c('ul', {
    staticClass: "ulMessageMenu"
  }, [_c('li', {
    staticClass: "liMessageMenu",
    class: _vm.optionClicked ? 'changeCursor ' + 'notselected' : 'selected',
    style: ({
      'height': '120px !important'
    })
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "aSurveyMessage",
    class: _vm.optionClicked ? 'changeCursor' : '',
    on: {
      "click": function($event) {
        _vm.sendMessage(_vm.getObjectMenu(_vm.message.message)[0].option)
      }
    }
  }, [_c('div', {
    staticClass: "faces centrado",
    style: ({
      'background-image': 'url(' + _vm.avatar5 + ')',
      'top': '0px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "centrado",
    style: ({
      'font-size': '9px!important',
      'top': '50px'
    })
  }, [_vm._v(_vm._s(_vm.getObjectMenu(_vm.message.message)[0].optionName[0]))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "aSurveyMessage",
    class: _vm.optionClicked ? 'changeCursor' : '',
    on: {
      "click": function($event) {
        _vm.sendMessage(_vm.getObjectMenu(_vm.message.message)[1].option)
      }
    }
  }, [_c('div', {
    staticClass: "faces centrado",
    style: ({
      'background-image': 'url(' + _vm.avatar4 + ')',
      'top': '0px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "centrado",
    style: ({
      'font-size': '9px!important',
      'top': '50px'
    })
  }, [_vm._v(_vm._s(_vm.getObjectMenu(_vm.message.message)[1].optionName[0]))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "aSurveyMessage",
    class: _vm.optionClicked ? 'changeCursor' : '',
    on: {
      "click": function($event) {
        _vm.sendMessage(_vm.getObjectMenu(_vm.message.message)[2].option)
      }
    }
  }, [_c('div', {
    staticClass: "faces centrado",
    style: ({
      'background-image': 'url(' + _vm.avatar3 + ')',
      'top': '0px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "centrado",
    style: ({
      'font-size': '9px!important',
      'top': '50px'
    })
  }, [_vm._v(" " + _vm._s(_vm.getObjectMenu(_vm.message.message)[2].optionName[0]) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "aSurveyMessage",
    class: _vm.optionClicked ? 'changeCursor' : '',
    on: {
      "click": function($event) {
        _vm.sendMessage(_vm.getObjectMenu(_vm.message.message)[3].option)
      }
    }
  }, [_c('div', {
    staticClass: "faces centrado",
    style: ({
      'background-image': 'url(' + _vm.avatar2 + ')',
      'top': '0px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "centrado",
    style: ({
      'font-size': '9px!important',
      'text-align': 'center !important',
      'top': '50px'
    })
  }, [_vm._v(" " + _vm._s(_vm.getObjectMenu(_vm.message.message)[3].optionName[0]) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "aSurveyMessage",
    class: _vm.optionClicked ? 'changeCursor' : '',
    on: {
      "click": function($event) {
        _vm.sendMessage(_vm.getObjectMenu(_vm.message.message)[4].option)
      }
    }
  }, [_c('div', {
    staticClass: "faces centrado",
    style: ({
      'background-image': 'url(' + _vm.avatar1 + ')',
      'top': '0px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "centrado",
    style: ({
      'font-size': '9px!important',
      'top': '50px'
    })
  }, [_vm._v(" " + _vm._s(_vm.getObjectMenu(_vm.message.message)[4].optionName[0]) + " ")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    staticClass: "holderInputs"
  }, [_c('v-card', {
    staticClass: "header-card",
    style: ({
      'background-color': _vm.$store.state.campaign.color,
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [(this.$store.state.isLowRes) ? _c('v-btn', {
    staticClass: "left-arrow-back",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.minimizeWindow($event)
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "28px !important"
    },
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "vtext-content",
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.getTitleMessage)
    }
  })])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "survey-content"
  }, [_c('star-rating', {
    staticClass: "star-rating-comp",
    attrs: {
      "show-rating": false,
      "increment": _vm.$store.state.campaign.fullStars == 0 ? 0.5 : 1
    },
    model: {
      value: (_vm.rating),
      callback: function($$v) {
        _vm.rating = $$v
      },
      expression: "rating"
    }
  }), _vm._v(" "), (_vm.$store.state.campaign.show_email) ? _c('v-switch', {
    staticClass: "switch-align",
    attrs: {
      "color": _vm.$store.state.campaign.color,
      "label": _vm.$t('sendbymail')
    },
    model: {
      value: (_vm.sendmail),
      callback: function($$v) {
        _vm.sendmail = $$v
      },
      expression: "sendmail"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "containerTextArea",
    staticStyle: {
      "padding": "9px 20px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('message'),
      "maxlength": "300",
      "counter": "300"
    },
    model: {
      value: (_vm.surveyMessage),
      callback: function($$v) {
        _vm.surveyMessage = $$v
      },
      expression: "surveyMessage"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    style: ({
      'background-color': _vm.$store.state.campaign.color,
      'color': _vm.invertColor(_vm.$store.state.campaign.color)
    }),
    attrs: {
      "id": "btnEnviar",
      "round": ""
    },
    on: {
      "click": _vm.clickSend
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('sendpunctuation')) + "  \n        "), _c('v-icon', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("send")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "border-radius-welcome",
    style: ({
      'background-color': _vm.$store.state.campaign.color,
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [(this.$store.state.isLowRes) ? _c('v-btn', {
    staticClass: "right-arrow-back",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.minimizeWindow($event)
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "28px !important"
    },
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("keyboard_arrow_left")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "vtext-content",
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.getText)
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "close-chat-modal",
    class: {
      'show': _vm.show
    },
    style: ({
      'background-color': _vm.$store.state.campaign.color,
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_c('div', [_vm._v(_vm._s(_vm.messageDialogue))]), _vm._v(" "), _c('v-btn', {
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    }),
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.confirmClosing($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('yes')))]), _vm._v(" "), _c('v-btn', {
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    }),
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelClosing($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('no')))])], 1)
},staticRenderFns: []}

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "id": "chronometer"
    }
  }, [_vm._v(_vm._s(_vm.chronometer))])
},staticRenderFns: []}

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "screen-share-dialog",
    class: {
      'show': _vm.show
    },
    style: ({
      'background-color': _vm.$store.state.campaign.color,
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('shareScreen')))]), _vm._v(" "), _c('v-btn', {
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    }),
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.yes($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('yes')))]), _vm._v(" "), _c('v-btn', {
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    }),
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.no($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('no')))])], 1)
},staticRenderFns: []}

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-form"
    }
  }, [_c('div', {
    staticClass: "cardHolder"
  }, [(_vm.getVisibleForm) ? _c('v-card', {
    staticClass: "main-form-div",
    style: ({
      'border-top': '2px solid ' + _vm.$store.state.campaign.color + '60'
    })
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": "",
      "xl12": ""
    }
  }, [_c('v-text-field', {
    ref: "namefield",
    staticClass: "form-input input-style first-input",
    style: ({
      'color': _vm.$store.state.campaign.color
    }),
    attrs: {
      "label": _vm.$t('name'),
      "rules": [function () { return !!_vm.client.name || _vm.$t('musttypename'); }],
      "error": _vm.errorCheck && _vm.client.name == '',
      "prepend-icon": "person",
      "required": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$refs.emailfield.focus($event)
      }
    },
    model: {
      value: (_vm.client.name),
      callback: function($$v) {
        _vm.$set(_vm.client, "name", $$v)
      },
      expression: "client.name"
    }
  })], 1), _vm._v(" "), (_vm.$store.state.campaign.show_email) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": "",
      "xl12": ""
    }
  }, [_c('v-text-field', {
    ref: "emailfield",
    staticClass: "form-input input-style",
    style: ({
      'color': _vm.$store.state.campaign.color
    }),
    attrs: {
      "label": _vm.$t('email'),
      "rules": [function () { return !!_vm.client.mail || _vm.$t('musttypemail'); }, function () { return _vm.emailRegex.test(_vm.client.mail) || _vm.$t('validemail'); }],
      "error": _vm.errorCheck && _vm.client.mail == '',
      "prepend-icon": "mail",
      "required": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$refs.customfield.focus($event)
      }
    },
    model: {
      value: (_vm.client.mail),
      callback: function($$v) {
        _vm.$set(_vm.client, "mail", $$v)
      },
      expression: "client.mail"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.campaign.custom_field.visible) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": "",
      "xl12": ""
    }
  }, [_c('v-text-field', {
    ref: "customfield",
    staticClass: "form-input input-style",
    style: ({
      'color': _vm.$store.state.campaign.color
    }),
    attrs: {
      "prepend-icon": "label",
      "label": _vm.$store.state.campaign.custom_field.text[_vm.$store.state.client.lang],
      "error": _vm.errorCheck && _vm.$store.state.campaign.custom_field.required && _vm.client.number == '',
      "required": _vm.$store.state.campaign.custom_field.required
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$refs.messagefield.focus($event)
      }
    },
    model: {
      value: (_vm.client.number),
      callback: function($$v) {
        _vm.$set(_vm.client, "number", $$v)
      },
      expression: "client.number"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": "",
      "xl12": ""
    }
  }, [_c('v-text-field', {
    ref: "messagefield",
    staticClass: "form-input input-style",
    style: ({
      'color': _vm.$store.state.campaign.color
    }),
    attrs: {
      "label": _vm.$t('message'),
      "rules": [function () { return !!_vm.client.initialMessage || _vm.$t('musttypemessage'); }],
      "error": _vm.errorCheck && _vm.client.initialMessage == '',
      "prepend-icon": "chat",
      "required": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.clickForm($event)
      }
    },
    model: {
      value: (_vm.client.initialMessage),
      callback: function($$v) {
        _vm.$set(_vm.client, "initialMessage", $$v)
      },
      expression: "client.initialMessage"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    style: ({
      'background-color': _vm.$store.state.campaign.color
    }),
    attrs: {
      "round": "",
      "small": "",
      "id": "btnEnviar"
    },
    on: {
      "click": _vm.clickForm
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px"
    },
    style: ({
      'color': _vm.invertColor(_vm.$store.state.campaign.color)
    })
  }, [_vm._v(_vm._s(_vm.$t('send')) + "  ")]), _vm._v(" "), _c('v-icon', {
    style: ({
      'color': _vm.invertColor(_vm.$store.state.campaign.color)
    }),
    attrs: {
      "dark": ""
    }
  }, [_vm._v("send")])], 1)], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible && _vm.message && _vm.menuMessage(_vm.message.message)) ? _c('li', {
    class: {
      'self': _vm.message && _vm.message.self, 'other': _vm.message && !_vm.message.self
    }
  }, [_c('messageMenu', {
    ref: "menuMessage",
    attrs: {
      "message": _vm.message
    }
  })], 1) : (_vm.message && _vm.surveyMessage(_vm.message.message)) ? _c('li', {
    class: {
      'self': _vm.message && _vm.message.self, 'other otherSurvey': _vm.message && !_vm.message.self
    }
  }, [(_vm.isFaces(_vm.message.message)) ? _c('messageSurvey', {
    ref: "surveyMessage",
    attrs: {
      "message": _vm.message
    }
  }) : (_vm.isYesNo(_vm.message.message)) ? _c('messageSurveyYesNo', {
    attrs: {
      "message": _vm.message
    }
  }) : _vm._e()], 1) : (_vm.message && _vm.visible) ? _c('li', {
    class: {
      'self': _vm.message && _vm.message.self, 'other': _vm.message && !_vm.message.self
    }
  }, [_c('div', {
    staticClass: "containerMessage"
  }, [_c('div', {
    staticClass: "msg",
    style: ({
      'background-color': _vm.message && !_vm.message.self ? _vm.$store.state.campaign.color : '#e8e7e7'
    })
  }, [_vm._l((_vm.getEnters(_vm.message.message)), function(item, index) {
    return _c('p', {
      directives: [{
        name: "linkify",
        rawName: "v-linkify"
      }],
      key: index,
      class: {
        'black-text': _vm.message && _vm.message.self
      },
      style: ({
        'color': _vm.invertColor(_vm.$store.state.campaign.color)
      }),
      attrs: {
        "message": item
      }
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "files": _vm.message.attachments
    }
  })], 2), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$moment(_vm.message.date).format('HH:mm')))])])]) : (_vm.visible) ? _c('li', {
    staticClass: "other"
  }, [_c('div', {
    staticClass: "load-3 msg padding-typing",
    style: ({
      'background-color': _vm.$store.state.campaign.color
    })
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "element-top"
  }, [_c('div', [(_vm.show) ? _c('v-toolbar', {
    staticClass: "call-toolbar elevation-0",
    class: {
      'show': _vm.show
    },
    attrs: {
      "dark": "",
      "height": "34px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "call-title"
  }, [_vm._v(_vm._s(_vm.$t('calling')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('duration'))), (_vm.show) ? _c('chronometer') : _vm._e()], 1), _vm._v(" "), (_vm.isOnVideoCall) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.switchShowVideo
    },
    slot: "activator"
  }, [_c('v-icon', {
    domProps: {
      "textContent": _vm._s(_vm.showTextInput ? 'remove_red_eye' : 'notes')
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('write')))])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.mutebutton
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "mic-mute red--text darken-1",
    attrs: {
      "color": "#fff"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mute ? 'mic_off' : 'mic')
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.mute ? _vm.$t('unmute') : _vm.$t('mute')))])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "hangup-button ma-0",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.hangup
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticStyle: {
      "transform": "rotate(135deg)"
    }
  }, [_vm._v("phone")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('hangup')))])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.video),
      expression: "video"
    }],
    ref: "agentself",
    class: {
      'show': _vm.showVideo
    },
    attrs: {
      "id": "agentsCamera",
      "autoplay": "",
      "playsinline": ""
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "myCameraContainer"
    }
  }, [_c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.video),
      expression: "video"
    }],
    ref: "myself",
    attrs: {
      "id": "myCamera",
      "autoplay": "",
      "playsinline": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "action-icons-bar",
    style: ({
      'background-color': this.$store.state.campaign.color
    }),
    attrs: {
      "height": "67px",
      "card": ""
    }
  }, [_c('v-toolbar-title', [(this.$store.state.isLowRes) ? _c('v-btn', {
    staticClass: "left-arrow-back",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.minimizeWindow($event)
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "28px !important"
    },
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("keyboard_arrow_left")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.campaign.show_agent && !_vm.$store.state.interaction.transfering) ? _c('div', {
    staticClass: "avatar-agent-pic",
    class: {
      'isLowRes': this.$store.state.isLowRes
    },
    style: ({
      'background-image': 'url(' + _vm.$store.state.menu.menu_img + ')'
    })
  }) : (!_vm.$store.state.interaction.transfering) ? _c('div', {
    staticClass: "avatar-agent-pic",
    class: {
      'isLowRes': this.$store.state.isLowRes
    },
    style: ({
      'background-image': 'url(' + _vm.avatar + ')'
    })
  }) : (_vm.$store.state.interaction.transfering) ? _c('div', {
    staticClass: "avatar-agent-pic",
    class: {
      'isLowRes': this.$store.state.isLowRes
    }
  }, [_c('v-icon', {
    staticClass: "spinIcon",
    staticStyle: {
      "font-size": "50px !important"
    },
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("\n          sync\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.campaign.show_agent && !_vm.$store.state.interaction.transfering) ? _c('span', {
    staticClass: "agent-name",
    class: {
      'isLowRes': this.$store.state.isLowRes
    },
    style: ({
      'color': _vm.invertColor(_vm.$store.state.campaign.color)
    })
  }, [_vm._v(_vm._s(_vm.$store.state.interaction.agent))]) : (!_vm.$store.state.campaign.show_agent && !_vm.$store.state.interaction.transfering) ? _c('span', {
    staticClass: "agent-name",
    class: {
      'isLowRes': this.$store.state.isLowRes
    },
    style: ({
      'color': _vm.invertColor(_vm.$store.state.campaign.color)
    })
  }, [_vm._v("CHAT")]) : (_vm.$store.state.interaction.transfering) ? _c('span', {
    staticClass: "agent-name",
    class: {
      'isLowRes': this.$store.state.isLowRes
    },
    style: ({
      'color': _vm.invertColor(_vm.$store.state.campaign.color)
    })
  }, [_vm._v(_vm._s(_vm.$t('transfering')))]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.interaction.transfering) ? _c('p', {
    staticClass: "response-time",
    class: {
      'isLowRes': this.$store.state.isLowRes
    },
    style: ({
      'color': _vm.invertColor(_vm.$store.state.campaign.color)
    })
  }, [_vm._v(_vm._s(_vm.$t('available')))]) : _vm._e()], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [(_vm.allowedCalls && _vm.hasWebRTC && !_vm.hideButtons && !_vm.$store.state.interaction.transfering) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "chatbar-button",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.videoCall($event)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("videocam")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('videocall')))])], 1) : _vm._e(), _vm._v(" "), (_vm.allowedCalls && _vm.hasWebRTC && !_vm.hideButtons && !_vm.$store.state.interaction.transfering) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "chatbar-button",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.makeCall($event)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("phone")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('call')))])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "chatbar-button",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openCloseModal($event)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('endchat')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.allowedDomain) ? _c('v-app', [_c('welcome-message', {
    staticClass: "welcome-message-header",
    class: {
      'show': _vm.showWelcome
    }
  }), _vm._v(" "), _c('router-view', {
    ref: "view"
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 421 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 422 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[260]);


// WEBPACK FOOTER //
// static/js/app.27e47e63e6734735e444.js